import { IIsiDtoComponentClientState, IIsiDtoUI, IsiDataTransferObject, IsiDtoUIClientState } from "../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";
﻿import { DateHelper } from "../core.date";
import { Logger } from "../core.log";
import { addParamToUrl, detectChrome, detectChromeMobile, detectEdge, detectEdgeMobile, detectFirefox, detectFirefoxMobile, detectIE, detectIEMobile, detectiPad, detectiPhone, detectOpera, detectSafari, detectSafariMobile, IsiBrowser, IsiJsTools, updateDeviceInfos, _IsiIsPopin } from "../core.ts";
import { IIsiPageController } from "./Core/Component/IIsiPageController";
import { IsiComponentFactory } from "./Core/Component/IsiComponentFactory";
import { IsiPageController } from "./Core/Component/IsiPageController";
import { IsiClientCacheManager } from "./Core/Manager/IsiClientCacheManager";
import { IsiComponentManager } from "./Core/Manager/IsiComponentManager";
import { IsiPageRequestManager } from "./Core/Manager/IsiPageRequestManager";
import { IIsiPopInSettingsConstructorArgs } from "./Core/Popin/IIsiPopInSettingsConstructorArgs";
import { IIsiPopInSettingsOpenSettings } from "./Core/Popin/IIsiPopInSettingsOpenSettings";
import { IIsiUITreatment } from "./Core/Treatment/IIsiUITreatment";
import { IIsiUITreatmentConstructorArgs } from "./Core/Treatment/IIsiUITreatmentConstructorArgs";
import { IsiRWDLength, IsiRWDMode, IsiRWDOrientation, UnitTypeAsString, WebBrowser } from "./IsiFW.enums";
import { IsiFormValidateManager } from "./IsiFW.ui.FormValidateManager";
import { IsiEventHandlerList } from "./Utilities/IsiEventHandlerList";


////import "./../../es-module-shims/dist/es-module-shims.js";
//import "./../../DOMPurify/dist/purify.min.js";
//import "./../../jquery/jquery.isilog.js";
//import "./../../jquery/jquery-ui.js";
//import "./../../jquery/jquery.json.min.js";
//import "./../../jquery/jquery.alphanumeric.pack.js";
//import "./../../jquery/jquery.rotate.min.js";
//import "./../../jquery/jquery.easing.min.js";
//import "./../../Dropzone/dropzone.js";
//import "./../../jquery/fancybox/jquery.fancybox.js";
//import "./../../Swiper/js/swiper.js";
//import "./../../Velocity/velocity.min.js";
//import "./../../mobiscroll/js/mobiscroll.jquery.min.js";
//import "./../../momentjs/moment.js";
//import "./../../momentjs/locale/fr.js";
////import "./../momentjs/moment-duration-format.js";
//import "./../../Spectrum/spectrum.js";
//import "./../../Spectrum/i18n/jquery.spectrum-fi.js";
////import "./../Scrollbar/jquery.mCustomScrollbar.concat.min.js";
//import "./../../IsiWebGUI/core.storage.js";
//import "./../../IsiWebGUI/core.js";
//import "./../../IsiWebGUI/core.translation.js";
//# sourceMappingURL=vintageCore.bundle.js.map

//window.jQuery = jQuery;
var popInInstances: IsiPopInSettings<any, any>[] = [];

const fancyboxIframeSelector = ".fancybox-iframe";

if (typeof (window.IsiPageControllerExternalInitialization) == 'undefined') {
    window.IsiPageControllerExternalInitialization = function (controller) { return true; };
}

// A déplacer dans core.js du framework
if (!String.IsiFormat) {
    String.IsiFormat = function (format, args) {
        var format = format || arguments[0];
        if (!Array.isArray(args)) {
            args = Array.prototype.slice.call(arguments, 1);
        }
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

String.prototype.IsiReplaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
}

String.prototype.IsiEndsWith = function (string) {
    return (this.substr(this.length - string.length) == string);
}



//-------------------------------------------------------------

/**
 * La configuration
 * @typedef {Object} IsiUiTreatmentArgs
 * @param {Object} context Le contexte d'exécution JS (permet de définir le this). Dans le cas de l'appel à la méthode d'un objet, l'objet doit être passé ici. Si rien est passé, le contexte window est utilisé
 * @property {String|Function} func La méthode à appeler
 * @property {Object[]} args Le tableau (notation []) d'arguments à passé à la méthode
 * @property {String} id L'identifiant du traitement. Si rien n'est spécifié et que le paramètre args.func est de type chaine, celui-ci est utilisé comme id.
 * @property {Boolean} blocking Indique si le traitement est bloquant ou non
 * @property {Object} callbackOf Indique le traitement pour lequel celui-ci est un callback
 * @property {Function} if Fonction permettant d'effectuer une condition d'éxécution du traitement. Celle-ci doit renvoyer true ou false
 * @property {Boolean} root Indique si le traitement doit être obligatoirement géré comme traitement racine c'est à dire à l'engine principale (la plus haute). Si un traitement est en cours, celui-ci ne sera donc pas ajouté comme sous-traitement.
*/

/**
 * Dto représentant un client
 * @typedef {Object} IIsiDtoClient
 * @property {IIsiUnit} IsiWidth Largeur
 * @property {IIsiUnit} IsiHeight Hauteur
 * @property {String} IsiProtocol Protocole
 * @property {String} IsiHostname Nom d'hôte
 * @property {Integer} IsiPort Port
 * @property {Boolean} InputDate Le client gère les champs de type date ?
 * @property {IsiRWDMode} RWDMode Mode RWD
 * @property {IsiRWDLength} RWDLength taille Mode RWD
 * @property {IsiRWDOrientation} RWDOrientation Orientation RWD
 * @property {WebBrowser} WebBrowser Navigateur Web
*/

/**
 * @class IsiUITreatment
 * @param {IsiUiTreatmentArgs} args Les arguments de construction
 * @returns
 */
class IsiUITreatment implements IIsiUITreatment {
    _treatmentThis: any;
    _treatmentFunction: (() => void) | string;
    _treatmentArgs: any;
    _id: string;
    _blocking: boolean;
    _callbackOf: IIsiUITreatment;
    _executeIf: (result: any) => boolean;
    _isRootTreatment: boolean;
    _isSubmitTreatment: boolean;
    _isAlertTreatment: boolean;

    _returnValue: any;
    _parentTreatment: IsiUITreatment;
    _executed: boolean;
    _funcExecuted: boolean;
    _subTreatments: IsiUITreatmentEngine;
    _callbackTreatments: IsiUITreatmentEngine;
    _engine: IsiUITreatmentEngine;
    _logReportId: number;

    constructor(args: IIsiUITreatmentConstructorArgs) {
        this._treatmentThis = args.context || null;
        this._treatmentFunction = args.func || null;
        this._treatmentArgs = args.args || null;
        this._id = args.id || null;
        this._blocking = args.blocking || false;
        this._callbackOf = args.callbackOf || null;
        this._executeIf = args["if"] || function () { return true; };
        this._isRootTreatment = args.root || false;
        this._isSubmitTreatment = args.isSubmit || false;
        this._isAlertTreatment = args.isAlert || false;

        this._returnValue = null;
        this._parentTreatment = null;
        this._executed = false;
        this._funcExecuted = false;
        this._subTreatments = new IsiUITreatmentEngine();
        this._callbackTreatments = new IsiUITreatmentEngine();
        this._engine = null;
    }

    getLogReportId() {
        if (!this._logReportId) {
            this._logReportId = uiCore.getTreatmentLogger().getNewTreatmentId();
        }
        return this._logReportId;
    }
    getParentLogReportId() {
        if (this._parentTreatment) {
            return this._parentTreatment.getLogReportId();
        }
        return "";
    }
    getFunc() {
        return this._treatmentFunction;
    }
    /**
     * Obtient le fonction permettant d'évaluer si le traitement doit être exécuté
     * @returns {Function}
     */
    getExecuteIf() {
        return this._executeIf;
    }
    /**
     * Définit la fonction permet d'évaluer la condition d'exécution du traitement
     * @param {Function} value Fonction devant renvoyer True ou False. Le traitement s'exécute si elle renvoie True.
     */
    setExecuteIf(value) {
        if (!(value instanceof Function)) { throw new IsiInvalidArgumentException("value", ["Function"]); }
        this._executeIf = value;
    }
    /**
     * Obtient l'engine associée à ce traitement
     */
    getEngine() {
        return this._engine;
    }
    setEngine(value) {
        this._engine = value;
    }
    /**
     * Obtient l'engine associée aux sous-traitement de ce traitement
     */
    getSubTreatmentsEngine() {
        return this._subTreatments;
    }
    execute(unblock) {
        var loggerTreatmentInfos;
        var resultOfCallbackedTreatment = null;
        var resultOfCondition = true;
        var ensureParentCallbacks = false;

        if (unblock) {
            // Le traitement est le traitement courant, on débloque l'interface
            uiCore.unregisterBlockingTreatment(this);
        }

        // Le traitement n'à pas déjà été exécuté dans sa globalité (traitement lui-même + sous-traitements) ?
        if (!this.wasExecuted()) {
            loggerTreatmentInfos = uiCore.getTreatmentLogger().getTreatment(this.getId());

            if (this.getCallbackOf()) {
                // Dans le cas ou le traitement est un callback d'un autre traitement, on récupère la valeur de retour de l'autre traitement
                resultOfCallbackedTreatment = this.getCallbackOf().getReturnValue();
            }
            // Evaluation de la condition d'éxécution du traitement si il y en a une
            if (this.getExecuteIf() && this.getExecuteIf()(resultOfCallbackedTreatment)) {

                loggerTreatmentInfos.executeOrder.push(uiCore.getTreatmentLogger().getNextExecuteOrderCounter());

                // Le traitement n'a pas déjà été exécuté
                if (!this._funcExecuted) {
                    // Une fonction de traitement a été fourni ?
                    if (this._treatmentFunction) {
                        var func;
                        var result;

                        // On récupère la fonction (fonction sur l'objet window ou fonction d'un objet)
                        func = this._treatmentFunction;
                        if (!(func instanceof Function)) {
                            if (this._treatmentThis) {
                                func = this._treatmentThis[<string>(<unknown>this._treatmentFunction)];
                            } else {
                                func = window[<string>(<unknown>this._treatmentFunction)];
                            }
                        }



                        if (this.getCallbackOf()) {
                            // Le traitement est le callback d'un autre traitement
                            uiCore.logForTreatment(loggerTreatmentInfos, "Execution du callback du traitement {0}", this.getCallbackOf().getId());
                            result = func.apply(this._treatmentThis, [resultOfCallbackedTreatment]);
                        } else {
                            if (this.getId()) {
                                uiCore.log("Execution du traitement {0}", this.getId());
                            } else {
                                uiCore.log("Execution d'un traitement anonyme");
                            }

                            // On appelle la fonction du traitement
                            result = func.apply(this._treatmentThis, this._treatmentArgs);


                        }
                        // On set la valeur de retour sur l'objet
                        this.setReturnValue(result);
                        //if (!this._subTreatments.existsNotExecutedTreatment()) {
                        //    // On set la valeur de retour sur l'objet
                        //    this.setReturnValue(result);
                        //} else {
                        //    uiCore.logForTreatment(loggerTreatmentInfos, "Attention : le resultat du traitement {0} est non concluant car il existe des sous-traitements non exécutés", this.getId());
                        //}


                        //if (this.getCallbackOf()) {
                        //    this.getCallbackOf().setReturnValue(result);
                        //}

                        // On indique que la fonction du traitement a été exécuté
                        this._funcExecuted = true;

                        if (this.getBlocking()) {
                            //Si le traitement est bloquant, on indique que l'interface est bloquée
                            uiCore.registerBlockingTreatment(this);
                        }
                    }
                }

                if (this.getBlocking()) {
                    // Traitement bloquant, on ne fait rien ici pour l'instant
                } else {
                    // Le traitement n'est pas bloquant, on déclenche les sous-traitements
                    this._subTreatments.execute(unblock);
                    if (!this._subTreatments.existsNotExecutedTreatment()) {
                        // Tous les sous traitements ont été exécuté, on peut dire que le traitement à été exécuté dans sa globalité
                        this._executed = true;
                        if (typeof (this.getReturnValue()) !== 'undefined' && this.getReturnValue() !== null) {
                            //uiCore.log("Resultat du traitement {0} : {1}", this.getId(), JSON.stringify(this.getReturnValue()));
                            if (loggerTreatmentInfos) {
                                loggerTreatmentInfos.result = JSON.stringify(this.getReturnValue());
                            }
                        } else {
                            uiCore.log("Le traitement {0} a été éxecuté mais il n'a pas renvoyé de resultat", this.getId());
                        }

                        ensureParentCallbacks = unblock;

                        //if (this.getCallbackOf()) {
                        //    if (this.getCallbackOf()._parentTreatment) {
                        //        if (this.getCallbackOf()._parentTreatment._engine._currentTreatment == this) {
                        //            this.getCallbackOf()._parentTreatment._engine._currentTreatment = null;
                        //        }
                        //    }

                        //}
                    }
                }
            } else {
                // Dans le cas ou la condition du traitement renvoie faux, on indique que le traitement a été exécuté
                this._funcExecuted = true;
                this._executed = true;
                resultOfCondition = false;
            }
            // Si le traitement a été éxecuté et que la condition et vrai on traite les callBack
            if (this.wasExecuted() && resultOfCondition) {
                this._callbackTreatments.execute(unblock);
            }

            if (ensureParentCallbacks) {
                this._ensureParentCallBack(loggerTreatmentInfos);
            }

        }

        return true;
    }
    _ensureParentCallBack(loggerTreatmentInfos) {
        let currentTreatment = this;
        var parentTreatment = currentTreatment.getParentTreatment();

        if (parentTreatment
            && parentTreatment.wasExecuted()
            && !parentTreatment.getSubTreatmentsEngine().existsNotExecutedTreatment()
            && (parentTreatment.getSubTreatmentsEngine().getCurrentTreatment() === this || uiCore.canExecuteCallbackOfAllParentTreatments())) {

            uiCore.logForTreatment(loggerTreatmentInfos, "EnsureParentCallBacks", currentTreatment.getId());

            parentTreatment._executeCallbacks();

            if (uiCore.canExecuteCallbackOfAllParentTreatments()) {
                parentTreatment._ensureParentCallBack(loggerTreatmentInfos);
            }
        }
    }
    _executeCallbacks(unblock?) {
        this._callbackTreatments.execute(unblock);
    }
    /**
     * Obtient l'id du traitement. La fonction renvoi par ordre de priorité :
     *  - 1 : l'id si il a été spécifié à la création du traitement
     *  - 2 : le nom de la fonction spécifié à la création du traitement si il s'agit d'une chaine de caractère (et non d'un objet fonction)
     *  - 3 : une chaine vide
     * @returns {String}
     */
    getId() {
        return this._id;
    }
    setId(value) {
        this._id = value;
    }
    getAutoSetReturnGlobally() {
        return (typeof this.getId() === 'string') && !this.getBlocking();
    }
    /**
     * Permet de savoir si le traitement à un id (c'est à dire différent de chaine vide)
     * @returns {Boolean}
     */
    haveId() {
        return this._id != "" && this._id != null;
    }
    /**
     * Obtient si le traitement est bloquant (lorsqu'il a été exécuté et débloqué, il devient non bloquant)
     * @returns {Boolean}
     */
    getBlocking() {
        return this._blocking;
    }
    setBlocking(value) {
        this._blocking = value;
    }
    /**
     * Obtient le traitement pour lequel ce traitement est un callback
     * @returns {IsiUITreatment}
     */
    getCallbackOf() {
        return this._callbackOf;
    }
    /**
     * Obtient la valeur de retour du traitement
     * @returns {*}
     */
    getReturnValue() {
        return this._returnValue;
    }
    /**
     * Définit la valeur de retour du traitement
     * @param {*} value
     */
    setReturnValue(value) {
        this._returnValue = value;
        if (this.getAutoSetReturnGlobally()) {
            // On set la valeur de retour globalement sur l'objet uiCore si il faut le faire
            uiCore.setData(this.getId(), value);
        }
    }
    /**
     * Permet d'ajouter un sous-traitement
     * @param {IsiUITreatment} treatment
     */
    addTreatment(treatment) {
        var isCallback = false;
        treatment.setParentTreatment(this);
        if (treatment.getCallbackOf()) {
            if (treatment.getCallbackOf() === this) {
                isCallback = true;

                if (!treatment.haveId()) {
                    // Le traitement n'a pas d'Id est c'est un callback, alors on lui en construit un
                    treatment.setId("CallbackOf " + treatment.getCallbackOf().getId());
                }
            }
        }

        if (isCallback) {
            this._callbackTreatments.addTreatment(treatment);
        } else {
            this._subTreatments.addTreatment(treatment);
        }

    }
    /**
     * Indique si le traitement a été exécuté dans sa globalité (traitement et ses sous-traitements)
     * @returns {Boolean}
     */
    wasExecuted() {
        return this._executed;
    }
    /**
     * Indique si la fonction du traitement a été exécuté (ne s'occupe pas de ses sous-traitements)
     * @returns {Boolean}
     */
    funcWasExecuted() {
        return this._funcExecuted;
    }
    /**
     * Récupère le traitement parent
     */
    getParentTreatment() {
        return this._parentTreatment;
    }
    /**
     * Définit le traitement parent
     * @param {IsiUITreatment} value
     */
    setParentTreatment(value) {
        this._parentTreatment = value;
    }
    /**
     * Indique si le traitement à un traitement parent (et donc est un sous-traitement)
     * @returns {Boolean}
     */
    haveParentTreatment() {
        return this._parentTreatment !== null;
    }
    getIsRoot() {
        return this._isRootTreatment;
    }
    getIsSubmit() {
        return this._isSubmitTreatment;
    }
    getIsAlert() {
        return this._isAlertTreatment;
    }
}

//------------------------------------------------

/**
 * @class IsiUITreatment
 * @constructor
 */
class IsiUITreatmentEngine {

    _treatments: IsiUITreatment[];
    _treatmentsById: {};
    _executedTreatments: IsiUITreatment[];
    _currentTreatment: IsiUITreatment;
    _blockingTreatment: IsiUITreatment;
    _isRoot: boolean;
    _parentEngine: IsiUITreatmentEngine;

    constructor(options?) {
        options = options || {};
        this._treatments = new Array();
        this._treatmentsById = {};
        this._executedTreatments = new Array();
        this._currentTreatment = null;
        this._blockingTreatment = null;
        this._isRoot = options.root || false;
        this._parentEngine = null;
    }

    /**
 * Définit l'engine au traitement
 * @param {IsiUITreatmentEngine} value
 */
    setParentEngine(value) {
        this._parentEngine = value;
    }
    /**
     * Permet de nettoyer la collection de traitement pour repartir à 0
     */
    clearTreatments() {
        uiCore.log("Suppression des traitements précédents");
        this._treatments = new Array();
        this._treatmentsById = {};
        this._executedTreatments = new Array();
        this._currentTreatment = null;
    }
    /**
     * Indique si le traitement passé en paramètre est le traitement courant de cette engine.
     * @param {IsiUITreatment} treatment
     */
    isCurrentTreatment(treatment) {
        return (this._currentTreatment === treatment);
    }
    /**
     * Indique si le traitement passé en paramètre est le traitement qui bloque l'engine.
     * @param {IsiUITreatment} treatment
     */
    isBlockingTreatment(treatment) {
        return (this._blockingTreatment === treatment);
    }
    /**
     * Permet d'ajouter un sous-traitement
     * @param {IsiUITreatment} treatment
     */
    addTreatment(treatment) {
        var id = treatment.getId();

        if (!id) {
            id = treatment.getFunc();
            if (typeof (id) !== 'string') {
                id = "";
            }
            treatment.setId(id);
        }

        if (treatment.haveId()) {
            // Le traitement à un Id, on l'ajoute dans la collection de traitement par Id pour pouvoir le retrouver plus facilement
            this._treatmentsById[treatment.getId()] = treatment;
        }

        if (this.existsTreatmentInProgress() && !treatment.getIsRoot()) {
            // Il existe un traitements en cours et le traitement ne doit pas être un traitement "racine", on l'ajoute comme sous-traitement
            this.getCurrentTreatment().addTreatment(treatment);
        } else {
            // Pas de traitement en cours
            if (treatment.getId()) {
                uiCore.log("Ajout du traitement {0}", treatment.getId());
            } else {
                uiCore.log("Ajout d'un traitement anonyme");
            }
            // On donne l'instance de l'engine au traitement
            treatment.setEngine(this);
            if (treatment.getParentTreatment()) {
                this.setParentEngine(treatment.getParentTreatment().getEngine());
            }

            uiCore.getTreatmentLogger().addNewTreatment(treatment);
            // Le traitement est un sous traitement

            // On ajoute le traitement
            this._treatments.push(treatment);

            // On vérifie si on peut l'exécuté immédiatement
            if (this._canExecuteTreatmentImmediatly(treatment)) {
                this._executeNextTreatment();
            }
        }
    }
    /**
     * Permet de déclencher l'exécution des traitements
     */
    execute(forceIfUIIsBlocked?) {
        var treatment;
        var stop = false;
        // ON vérifie si on peut exécuté les traitements (par de traitement bloquant en cours notamment)      
        if (this._canExecuteTreatmentImmediatly(null, forceIfUIIsBlocked)) {
            while (!stop && this.existsNotExecutedTreatment()) {
                // On exécute le traitement suivant
                treatment = this._executeNextTreatment();
                // On s'arrête si le traitement est bloquant ou si un traitement est en cours
                // On considère que les traitements déjà exécutés (et implicitement ceux dont la condition d'exécution retourne faux)
                // ne sont jamais bloquant (même s'ils ont l'option blocking à vrai)
                stop = (!treatment.wasExecuted() && treatment.getBlocking()) || !this._canExecuteTreatmentImmediatly(null, forceIfUIIsBlocked);
            }
        }

    }
    /**
     * Indique si il reste des traitements non exécutés
     */
    remainingNotExecutedTreatment() {
        return this._treatments.length > 0;
    }
    /**
     * Permet de débloquer un traitement. Cette fonction est à appelé lorsqu'un traitement bloquant rend la main et que sa valeur de retour est connue
     * @param {String} key Identifiant du traitement
     * @param {*} result Valeur de retour du traitement
     */
    unblockTreatment(key, result) {
        var treatment;
        treatment = this._treatmentsById[key];
        if (treatment) {
            // On indique que le traitement n'est plus bloquant
            treatment.setBlocking(false);

            // On renseigne sa valeur de retour
            treatment.setReturnValue(result);

            uiCore.log("Déblocage du traitement {0} : {1}", treatment.getId(), JSON.stringify(result));

            if (treatment.getEngine().isBlockingTreatment(treatment)) {
                // Le traitement est le traitement bloquant, on débloque l'interface

                //On vide la propriété blocking
                treatment.getEngine()._blockingTreatment = null;
                // On redemande l'exécution du traitement pour qu'il exécute ses sous-traitements
                this._executeTreatment(treatment, true);

                // On déclenche l'exécution de cette engine pour qu'elle reprenne l'exécution des traitements restants
                uiCore.executeRemainingTreatments();
            }
        }
    }
    /**
     * Indique si l'on peut exécuté le traitement passé en paramètre tout de suite
     * @param {IsiUITreatment} treatment
     */
    _canExecuteTreatmentImmediatly(treatment, forceIfUIIsBlocked?) {
        // Il n'y a pas de traitement en cours
        // ET l'objet uiCore indique que cela est possible (UI non bloquée, ...)
        // ET (le traitement n'est pas un callback OU c'est un callback et le traitement parent a été exécuté (sa fonction uniquement)
        return !this._currentTreatment &&
            uiCore.canExecuteTreatment(forceIfUIIsBlocked) &&
            (!treatment || (!treatment.getCallbackOf() || (treatment.getCallbackOf() && treatment.getCallbackOf().funcWasExecuted())));
    }
    /**
     * Permet de déclencher l'exécution du traitement suivant
     */
    _executeNextTreatment() {
        var treatment;

        treatment = this._treatments.splice(0, 1)[0];
        this._executeTreatment(treatment, false);

        return treatment
    }
    /**
     * Permet de lancer l'exécution d'un traitement
     * @param {IsiUITreatment} treatment Le traitement a exécuter
     */
    _executeTreatment(treatment, unblock) {
        // Il devient le traitement courant
        this._currentTreatment = treatment;
        treatment.execute(unblock);

        if (treatment.getBlocking()) {
            // Si le traitement est bloquant
            this._currentTreatment = null;
            // On stoque sur l'engine le traitement bloquant
            this._blockingTreatment = treatment;
        } else {
            if (treatment.wasExecuted()) {
                // Le traitement a été exécuté dans son ensemble, on peut le classer
                this._endTreatment(treatment);
            } else {
                // Le traitement n'a pas été exécuté dans son ensemble, on le remet dans la collection des traitements à exécuter pour revenir dessus
                this._treatments.splice(0, 0, treatment);
                this._currentTreatment = null;
            }
        }
    }
    /**
     * Permet de "classer" un traitement lorsqu'il est complétement terminé
     * @param {IsiUITreatment} treatment
     */
    _endTreatment(treatment) {
        this._executedTreatments.push(treatment);
        this._currentTreatment = null;

    }
    /**
     * Indique si il reste des traitement non exécutés
     * @returns {Boolean}
     */
    existsNotExecutedTreatment() {
        return (this._treatments.length > 0) || (this._currentTreatment && !this._currentTreatment._executed);
    }
    existsTreatmentInProgress() {
        return (this._currentTreatment != null);
    }
    getCurrentTreatment() {
        return this._currentTreatment;
    }
    getTreatment(id) {
        return this._treatmentsById[id];
    }
    getExecutedTreatments() {
        return this._executedTreatments;
    }
}

//--------------------------------------
export class IsiUICore<TFinal extends IsiUICore<TFinal>> {

    /**
     * Contient le uiCore parent (ex celui du formulaire lorsque l'on est dans une popin)
     */
    _parent: TFinal;

    _options: IIsiDtoUI;
    _detectClient: boolean;

    _uiTreatmentEngine = new IsiUITreatmentEngine({ root: true });
    _datas = {};
    _submit = true;
    _scrollButtonOptions: any;
    _feedbackOptions: any;
    _feedbackZone;
    _feedbackZoneContentText;
    _motion: boolean;
    // CLEM - Dysf74129 - surchargeable via les options et desactivé par defaut
    _isModeDiag: boolean;
    _loggerInitialized = false;

    _currentPopin: IsiPopInSettings<unknown, unknown> = null;
    _alertTreatments = new Array();
    _blockingTreatments = new Array();
    _hideFeedbackInProgress = false;
    _onHideFeedbackComplete;
    _ajaxFileUpload;
    _canExecuteCallbackOfAllParentTreatments: boolean;

    _graphvizReport = new IsiGraphViz();

    //GBAU RWD
    _events: IsiEventHandlerList;
    _jihdDtoClient;
    _client;
    _isRWD = null;
    _isRWDMobile = null;
    _isRWDTablet = null;
    _isRWDPhone = null;
    _isRWDVTabletOrPhone = null;
    _isDesktopTouchMode = null;
    _componentManager: IsiComponentManager;
    _cachedWidth;
    _cachedHeight;
    _unload = false;
    _forceRichTextFocus = false;
    _clientCacheManager: IsiClientCacheManager;

    //Contient les callbacks à appeler une fois le IsiComponentManager trouvé
    _whenComponentManagerFoundHandlers: ((componentManager: IsiComponentManager) => void)[];
    _onBackButtonCallback: () => void;
    browser: any;
    //On préfixe pour les clefs utilisés dans le sessionStorage
    _sessionStoragePrefix: string;
    //On préfixe pour les clefs utilisés dans le localStorage
    _localStoragePrefix: string;
    _previousScrollPosition: number;
    _userJustDoHistoryBack: boolean;
    _cancelNextHistoryPopState: boolean;
    logger: Logger;
    popinCmp: any;
    pageUpBtn: any;
    initTabulation: () => void;
    _historyBackTimeout: number;
    setFocusOnPopin: () => void;

    _formValidateManager: IsiFormValidateManager;
    _state: IsiDtoUIClientState;
    private _componentFactory: IsiComponentFactory;
    private _controller: IIsiPageController;

    constructor(options, parent?: TFinal) {
        this._parent = parent;

        options = options || {};
        this._options = options;

        options.feedback = options.feedback || {};
        options.feedback.openFrom = "t";
        options.feedback.closeDirection = "fadeOut"; //t fadeOut
        options.enableFileDragNDrop = options.enableFileDragNDrop || false;
        // CLEM - Dysf74236
        options.feedback.timerDuration = 10000; // Durée avant masquage du feedback
        options.feedback.timerDurationFadeOut = 1500; // Durée du masquage du feedback 
        options.feedback.timeOut = null; // Timer avant disparition du feedback
        options.feedback.isEnabled = true; // Indique si les feedbacks ont le droit de s'afficher
        options.scrollButton = options.scrollButton || {};

        options.scrollButton.disabled = options.scrollButton.disabled || false;

        options.sessionStoragePrefix = options.sessionStoragePrefix || "";

        options.localStoragePrefix = options.localStoragePrefix || "";

        options.ruptureGrand = options.ruptureGrand || 1280;
        options.ruptureMoyen = options.ruptureMoyen || 992;
        options.rupturePetit = options.rupturePetit || 768;

        this._detectClient = options.detectClient && parent == null;

        //GBAU - 27/03/2018 - DEV141807 - Gestion de la navigation backward/forward + rafraichir
        //Permet d'activer ou non la navigation backward/forward dans le navigateur
        //Si cette option est à false, le back du navigateur est trappé
        options.allowHistoryBack = options.allowHistoryBack || false;


        this._uiTreatmentEngine = new IsiUITreatmentEngine({ root: true });
        this._datas = {};
        this._submit = true;
        this._scrollButtonOptions = options.scrollButton;
        this._feedbackOptions = options.feedback;
        this._feedbackZone;
        this._feedbackZoneContentText;
        this._motion = true;
        // CLEM - Dysf74129 - surchargeable via les options et desactivé par defaut
        this._isModeDiag = options.isModeDiag || false;
        this._loggerInitialized = false;

        this._currentPopin = null;
        this._alertTreatments = new Array();
        this._blockingTreatments = new Array();
        this._hideFeedbackInProgress = false;
        this._onHideFeedbackComplete;
        this._ajaxFileUpload;
        this._canExecuteCallbackOfAllParentTreatments = options.canExecuteCallbackOfAllParentTreatments || false;

        this._graphvizReport = new IsiGraphViz();

        //GBAU RWD
        this._events = new IsiEventHandlerList();
        this._jihdDtoClient;
        this._client;
        this._isRWD = null;
        this._isRWDMobile = null;
        this._isRWDTablet = null;
        this._isRWDPhone = null;
        this._isRWDVTabletOrPhone = null;
        this._isDesktopTouchMode = null;
        this._componentManager = null;
        this._cachedWidth;
        this._cachedHeight;
        this._unload = false;

        this._clientCacheManager = IsiClientCacheManager.getInstance();

        //Contient les callbacks à appeler une fois le IsiComponentManager trouvé
        this._whenComponentManagerFoundHandlers = [];

        if (this.getIsModeDiag()) {
            this._initLogger();
        }

        // Sur le déchargement, on met à jour un booléen qui bloque les removehandler qui arrivent trop tard
        jQuery(window).on("beforeunload", function (me) {
            return function (e) {
                me._unload = true;
            }
        }(this))

        if (options.enableFileDragNDrop) {
            //GBAU - 21/03/2016 - 113702 - On désactive le drag'n'drop de fichier
            this._configureFileDragNDrop();
        }

        this._onBackButtonCallback = options.onBackButton || function () { return true; };

        this.browser = {
            isIE: function () { return detectIE() != false; },
            isIEMobile: function () { return detectIEMobile() != false; },
            isEdge: function () { return detectEdge() != false; },
            isEdgeMobile: function () { return detectEdgeMobile() != false; },
            isChrome: function () { return detectChrome() !== false; },
            isChromeMobile: function () { return detectChromeMobile() !== false; },
            isFirefox: function () { return detectFirefox(); },
            isFirefoxMobile: function () { return detectFirefoxMobile(); },
            isOpera: function () { return detectOpera(); },
            isSafari: function () { return detectSafari(); },
            isSafariMobile: function () { return detectSafariMobile() !== false; },
            isMobile: function () { return detectIEMobile() !== false || detectEdgeMobile() !== false || detectChromeMobile() !== false || detectFirefoxMobile() !== false || detectSafariMobile() !== false },
            isiPhone: function () { return detectiPhone() !== false },
            isiPad: function () { return detectiPad() !== false }
        };
        //On préfixe pour les clefs utilisés dans le sessionStorage
        this._sessionStoragePrefix = options.sessionStoragePrefix;

        //On préfixe pour les clefs utilisés dans le localStorage
        this._localStoragePrefix = options.localStoragePrefix;

        this._previousScrollPosition = 0;

        this._userJustDoHistoryBack = false;
        this._cancelNextHistoryPopState = false;

        //this._initialize();
    }

    isDebug() {
        return jQuery("body").hasClass("debug");
    }
    isSlavePage() {
        return jQuery("body").hasClass("slavePage");
    }

    /**
     * Indique si c'est instance de IsiUICore est celle de plus haut niveau (c'est à dire qu'elle n'a pas de parente)
     */
    get isTop() {
        return this._parent == null;
    }

    get parent() {
        return this._parent;
    }

    get componentFactory() {
        return this._componentFactory;
    }

    get componentManager() {
        return this._componentManager;
    }

    get controller() {
        return this._controller;
    }

    set controller(value) {
        this._controller = value;
    }
    get pageRequestManager() {
        return IsiPageRequestManager.getInstance();
    }

    get state() {
        return this._state;
    }

    set state(value) {
        this._state = value;
    }

    get clientCacheManager() {
        return this._clientCacheManager;
    }

    getOptions() {
        return this._options;
    }

    // prop utilisée coté iws : iws_CanSetFocus (form.js)
    // pour savoir si on force le focus sur le champ rich ou on le garde sur le controle par défaut 
    get forceRichTextFocus() {
        return this._forceRichTextFocus;
    }

    set forceRichTextFocus(value) {
        this._forceRichTextFocus = value;
    }

    /**
     * @description cette methode premet de récupérer les coordonnées GPS du navigateur. ATTENTION CETTE METHODE NE FONCTION QUE EN HTTPS
     * @function getPositionGPS
     * @param {function} callBack envoie des infos en cas de succés
     * @param {function} callBackErr envoie des infos en d'erreur
     * @param {Objet} options définit les options 
     */
    getPositionGPS(callBack, callBackErr) {


        let geo = navigator.geolocation;

        if (navigator.geolocation) {
            let options = {
                timeout: 5000 //définit le temps du time-out. au bout de 5 s sans réponse on passe dans le callback error.
            };
            // Je récupére les coordonnées
            geo.getCurrentPosition(callBack, callBackErr, options);
        }
    }
    /**
     * Fonction a appeler avant une redirection
     * @param {IsiUICoreBeforeRedirectArgs} args Les arguments de construction
     * @returns {Boolean}
     */
    beforeRedirect(args) {
        args = args || false;
        if (args.keepState) {
            this.saveState();
        }
    }
    saveState() {
        if (!this._state.componentsClientState) {
            this._state.componentsClientState = {};
        }
        if (this.componentManager) {
            this.componentManager.saveState();
        }
        //Stocke l'état client d'UI dans un champ caché
        jQuery("#ihdClientState").val(JSON.stringify(this.state));
    }

    /**
     * Inscrit un état composant dans les états
     * @param id
     * @param state
     */
    registerCmpState(id: string, state: IIsiDtoComponentClientState) {
        if (!this._state.componentsClientState) {
            this._state.componentsClientState = {};
        }
        this._state.componentsClientState[id] = state;
    }

    getFormHeader() {
        return this.componentManager.getComponent<any>("FormHeader");
    }
    getCalendarPickerName() {
        return "CalendarPicker";
    }
    whenFormHeaderFound(handler) {
        this.whenComponentManagerFound(function (me) {
            return function () {
                me.componentManager.whenComponentFound("FormHeader", handler);
            }
        }(this));
    }
    getSessionId() {
        return this._getSessionIdOverridable();
    }
    _getSessionIdOverridable() {

    }
    getSessionStorageItem(key) {
        ///<summary>Fonction qui retourne l'élément stocké dans la sessionStorage (1 par onglet)</summary>
        return window.isiSessionStorage.getItem(this._sessionStoragePrefix + key);
    }
    setSessionStorageItem(key, value) {
        ///<summary>Fonction qui set l'élément stocké dans la sessionStorage (1 par onglet)</summary>
        window.isiSessionStorage.setItem(this._sessionStoragePrefix + key, value);
    }
    getLocalStorageItem(key) {
        ///<summary>Fonction qui retourne l'élément stocké dans le localStorage du navigateur</summary>
        return window.isiLocalStorage.getItem(this._localStoragePrefix + key);
    }
    setLocalStorageItem(key, value) {
        ///<summary>Fonction qui set l'élément stocké dans le localStorage du navigateur</summary>
        window.isiLocalStorage.setItem(this._localStoragePrefix + key, value);
    }
    getFormatedMessage(family, code, args) {
        const msg = this.getMessage(family, code);

        if (typeof msg === "string") {
            return window.formatMessage(msg, args);
        } else if (msg instanceof IsiTranslationMessage) {
            return window.formatMessage(msg.IsiLabel, args);
        } else {
            return msg;
        }
    }
    getMessage(family, code) {
        if (!this.isTop) return this.parent.getMessage(family, code);
        var msg = null;

        // Si la famille est UICORE, alors on regarde si le message est présent dans IsiComponentsTranslations
        if (family == 'UICORE' && typeof window.IsiComponentsTranslations != 'undefined') {
            msg = window.IsiComponentsTranslations.UICORE.Default[code];
        }

        if (!msg) {
            msg = this._getMessageOverridable(family, code);
        }

        return msg;
    }
    _getMessageOverridable(family, code) {
        ///<summary>Fonction surchargeable qui retourne un objet message par défaut celui stocké en cache(page js définie dans le répertoire script/locale)</summary>
        var message;

        if (typeof (window.IsiTranslations) == "undefined") {
            window.IsiTranslations = this.getSessionStorageItem("IsiTranslations");
        }

        if (typeof (window.IsiTranslations) !== "undefined" && window.IsiTranslations && window.IsiTranslations[family] && window.IsiTranslations[family][code]) {
            message = new IsiTranslationMessage(window.IsiTranslations[family][code]);
        } else {
            message = new IsiTranslationMessage({ familyCode: family, messageCode: code, message: family + "-" + code });
        }
        return message;
    }
    /**
     * Obtient le rapport Graphviz
     * @returns {Boolean}
     */
    getTreatmentLogger() {
        return this._graphvizReport;
    }
    /**
      * Création de l'objet de gestion des logs.
      */
    _initLogger() {
        try {
            this.logger = new Logger(this.getIsModeDiag());
            this._loggerInitialized = true;
        }
        catch (error) {
            console.error(error.message);
        }
    }
    /// Appelle la fonction "log" de la classe "Logger"
    log(message, ...args) {
        if (this.isLoggerInitialized()) {
            this.logger.log(message, args);
        }
    }
    /// Appelle la fonction "logElem" de la classe "Logger"
    logElem(el) {
        let value = "";
        if (this.isLoggerInitialized()) {
            value = this.logger.logElem(el);
        }
        return value;
    }
    /// Appelle la fonction "logForTreatment" de la classe "Logger"
    logForTreatment(treatmentInfos, message, args) {
        if (this.isLoggerInitialized()) {
            this.logger.logForTreatment(treatmentInfos, message, args);
        }
    }
    /// Appelle la fonction "logError" de la classe "Logger"
    logError(msg, ex?) {
        if (this.isLoggerInitialized()) {
            this.logger.logError(msg, ex)
        }
    }
    /// Appelle la fonction "logStack" de la classe "Logger"
    logStack(txt, trim) {
        if (this.isLoggerInitialized()) {
            this.logger.logStack(txt, trim);
        }
    }
    /// Appelle la fonction "logui" de la classe "Logger"
    logui(txt, jObj) {
        if (this.isLoggerInitialized()) {
            this.logger.logui(txt, jObj);
        }
    }
    /// Appelle la fonction "logBoundingClientRect" de la classe "Logger"
    logBoundingClientRect(txt, elem) {
        if (this.isLoggerInitialized()) {
            this.logger.logBoundingClientRect(txt, elem);
        }
    }
    getIsModeDiag() {
        return this._isModeDiag;
    }
    isLoggerInitialized() {
        return this._loggerInitialized;
    }
    /**
     * Définition du mode de diagnostique
     */
    setIsModeDiag(value) {
        this._isModeDiag = value;
        if (this._isModeDiag && typeof (this.logger) === "undefined") {
            this._initLogger();
        }
    }
    getCurrentPopin(): IsiPopInSettings<unknown, unknown> {
        if (!this.isTop) return this.parent.getCurrentPopin();
        return this._currentPopin;
    }
    setCurrentPopin(value: IsiPopInSettings<unknown, unknown>) {
        if (!this.isTop) return this.parent.setCurrentPopin(value);
        //GBAU - 24/05/2016 - DYSF74238 : Lorsqu'un popin est ouverte, on désactive le drag'n'drop de fichier
        //Si le drag'n'drop était possible, il faut s'en souvenir pour le réactiver à la fermeture
        if (jQuery("body").hasClass("canDropFile")) {
            jQuery("body").removeClass("canDropFile").addClass("canDropFileAfterClosePopin");
        }
        this._currentPopin = value;
    }
    closeCurrentPopin(result) {
        this.getCurrentPopin().close(result);
    }
    /**
     * Méthode noyau systématiquement appelée après la fermeture d'une popin
     * @param {IsiPopInSettings} popin L'objet associé à la popin
     * @returns boolean
     */
    _afterClosePopin(popin) {
        //GBAU - 24/05/2016 - DYSF74238 : A la fermeture, on vide la variable contenant la popin courante
        //Attention : lors de l'ouverture de popin successive, la popin courante n'est pas forcemment celle en cours de fermeture
        //car on passe ici après la fin de l'animation de fermeture (une autre à pu s'ouvrir entre temps)
        if (this._currentPopin == popin) {
            this._currentPopin = null;
        }

        //GBAU - 24/05/2016 - DYSF74238 : Lorsqu'un popin est ouverte, on désactive le drag'n'drop de fichier
        //Si le drag'n'drop était possible, on le réactive
        if (jQuery("body").hasClass("canDropFileAfterClosePopin")) {
            jQuery("body").removeClass("canDropFileAfterClosePopin").addClass("canDropFile");
        }


        return this._afterClosePopinOverridable(popin);
    }
    /**
     * Méthode noyau surchargeable systématiquement appelée après la fermeture d'une popin
     * @param {IsiPopInSettings} popin L'objet associé à la popin
     * @returns boolean
     */
    _afterClosePopinOverridable(popin) {
        return true;
    }
    _getPageName(win) {
        if (win) {
            return win.location.pathname.split("/").pop();
        }
        return "";
    }
    clearTreatments() {
        if (!this.isTop) return this.parent.clearTreatments();
        this._datas = {};
        this._submit = true;
        //this._uiBlocked = false;
        this._uiTreatmentEngine.clearTreatments();
        this._alertTreatments = new Array();
        this._blockingTreatments = new Array();
    }
    canExecuteTreatment(forceIfUIIsBlocked) {
        if (!this.isTop) return this.parent.canExecuteTreatment(forceIfUIIsBlocked);
        return forceIfUIIsBlocked || !this.getUIBlocked();
    }
    canExecuteCallbackOfAllParentTreatments() {
        if (!this.isTop) return this.parent.canExecuteCallbackOfAllParentTreatments();
        return this._canExecuteCallbackOfAllParentTreatments;
    }
    getUIBlocked() {
        if (!this.isTop) return this.parent.getUIBlocked();
        return this._blockingTreatments.length > 0;
    }
    registerBlockingTreatment(treatment) {
        if (!this.isTop) return this.parent.registerBlockingTreatment(treatment);
        this._blockingTreatments.push(treatment);
    }
    unregisterBlockingTreatment(treatment) {
        if (!this.isTop) return this.parent.unregisterBlockingTreatment(treatment);
        this._blockingTreatments = jQuery.grep(this._blockingTreatments, function (item) {
            return item.getId() !== treatment.getId();
        });
    }
    addUITreatment(args, parentTreatment?) {
        if (!this.isTop) return this.parent.addUITreatment(args, parentTreatment);
        var treatment;
        //var parentTreatment;
        var callbackArgs: any = false;
        var isSubTreatment;

        /*if (typeof (args.callbackOf) !== 'undefined') {
            parentTreatment = args.callbackOf;
        }*/

        treatment = new IsiUITreatment(args);

        callbackArgs = args.callback;
        parentTreatment = parentTreatment || this._uiTreatmentEngine;

        if (callbackArgs) {
            //Possibilité de passé directement une fonction en notation courte, on traduit alors dans l'objet requis
            if (callbackArgs instanceof Function) {
                callbackArgs = {
                    func: callbackArgs
                }
            }

            // On renseigne le traitement associé
            callbackArgs.callbackOf = treatment;

            // On ajoute le callback au traitement avant d'ajouter le traitement lui-même
            this.addUITreatment(callbackArgs, treatment);
        }

        if (treatment.getIsSubmit()) {
            this.addUITreatment(function (me) {
                return {
                    context: me,
                    func: "_beforeSubmit",
                    root: true
                }
            }(this));
        }

        if (treatment.getIsAlert()) {
            // Dans le cas ou le traitement est une alerte, on ajoute le traitement dans une collection séparé pour vérifier avant que le traitement
            // de submit soit exécuté que toutes les alertes ont bien été affichées
            this._alertTreatments.push(treatment);
        }

        parentTreatment.addTreatment(treatment);

        return treatment;
    }
    getData(key) {
        if (!this.isTop) return this.parent.getData(key);
        return this._datas[key];
    }
    setData(key, value) {
        if (!this.isTop) return this.parent.setData(key, value);
        this._datas[key] = value;
    }
    _beforeSubmit() {
        if (!this.isTop) return this.parent._beforeSubmit();
        this._showRemainingAlerts();
        return true;
    }
    showConfirm(options, callback?) {
        if (!this.isTop) return this.parent.showConfirm(options, callback);
        if (typeof (options) !== "object") {
            options = { message: options };
        }
        options.callback = options.callback || callback;

        if (options.message) {
            options.id = options.message;
        } else if (options.url) {
            options.id = options.url;
        }

        this._showConfirmOverridable(options);
    }
    _showConfirmOverridable(options) {

    }
    //SELI 0001026681 : PB0021889 - ISIWARE - SAINT HERBLAIN 
    disableFeedback() {
        this._feedbackOptions.isEnabled = false;
    }
    showFeedback(msg, error?, append?, iframe?) {
        if (!this._feedbackOptions.isEnabled) {
            return;
        }

        if (!this.isTop) return this.parent.showFeedback(msg, error, append, iframe);
        //CLEM - Dysf74236-  S'il y a deja un feedback ouvert, on le ferme
        // LBRI - en mode "append", il ne faut pas cacher pas le feedback
        if (!append) {
            this.hideFeedback();
        }

        //On déclare le traitement d'affichage
        var func = function (msg, error, append) {
            return function () {
                // LBRI - le premier appel ne peut pas être un "append"
                if (!this._feedbackZoneContentText) {
                    append = false;
                }
                this._ensureFeedbackZone();
                if (append) {
                    // Ajout d'un saut de ligne.
                    this._feedbackZoneContentText.append("<br>" + msg);
                    // YLAR 29/01/2019 : Dans le cas ou plusieurs messages sont concaténés, on garde le type erreur si un des message à afficher est en erreur. 
                    if (error) {
                        this._feedbackZone.addClass("error");
                    }
                } else {
                    if (iframe) {
                        this._feedbackZoneContentText.html('<iframe width="100%" id="feedbackIFrame" src="about:blank"></iframe>');
                        (<HTMLIFrameElement>document.getElementById('feedbackIFrame')).contentWindow.document.write(msg);
                    } else {
                        this._feedbackZoneContentText.html(msg);
                    }

                    this._showFeedback(error);
                }
            }
        }(msg, error, append);

        //Pas de feedback en cours de fermeture, on peut déclencer l'affichage tout de suite
        if (!this._hideFeedbackInProgress) {
            func.apply(this);
        } else {
            //UN feedback en cours de fermeture, on va attendre la fin de l'animation
            this._onHideFeedbackComplete = func;
        }

    }
    _ensureMessage(msg, options) {
        /// <summary>
        /// Elle permet de retourner le message final qui sera affiché.
        /// </summary>
        /// <param name="msg">Le message ou son identifiant.</param>
        /// <param name="options">Les options.</param>
        /// <returns>
        /// Le message
        /// </returns>
        /// <history>
        ///   <entry mat="YBRU" date="07/11/2016" task="1019263">Création</entry>
        /// </history>

        return this._ensureMessageOverridable(msg, options);
    }
    _ensureMessageOverridable(msg, options) {
        /// <summary>
        /// Elle permet de retourner le message final qui sera affiché.
        /// Cette fonction peut être surchargée dans le produit pour effectuer des 
        /// traitements spécifiques.
        /// </summary>
        /// <param name="msg">Le message ou son identifiant.</param>
        /// <param name="options">Les options.</param>
        /// <returns>Le message</returns>
        /// <history>
        /// 	<entry mat="YBRU" date="07/11/2016" task="1019263">Création</entry>
        /// </history>
        return msg;
    }
    _showMessage(msg, options) {
        if (msg) {
            msg = this._ensureMessage(msg, options);

            // Si on a pas l'option, on la set a false.
            options.debug = options.debug || false;
            options.popin = options.popin || false;
            options.append = options.append || false;
            options.error = options.error || false;

            // Si le message est long, qu'on a mis le debug ou qu'un taille et/ou une height est setter
            if (options.debug && ("height" in options) || ("width" in options) && options.width !== null || options.popin) {
                this._showMessageOverridable(msg, options);
            } else {
                this.showFeedback(msg, options.error, options.append, options.iframe);
            }
        }
    }
    showMessage(msg, options?) {
        if (!this.isTop) return this.parent.showMessage(msg, options);
        options = options || {};
        if (options.error) {
            throw "La méthode showMessage ne peut pas être une erreur, il faut utiliser showErrorMessage";
        } else {
            this._showMessage(msg, options);
        }
    }
    _showMessageOverridable(msg, options) {

    }
    showErrorMessage(msg, options?) {
        if (!this.isTop) return this.parent.showErrorMessage(msg, options);
        options = options || {};
        this.setSubmit(false);
        options.error = true;
        this._showMessage(msg, options);
    }
    hideFeedback(options?) {
        // CLEM 74236 - Si il y a une durée de passer, on l'utilise car on est en train de fermer le feedback via le timer
        if (this._feedbackZone) {
            this._hideFeedbackInProgress = true;
            if (this._motion && !uiCore.isTouchMode()) {
                var top;
                var left;
                var opacity = 1;
                var duration = 400;
                top = this._feedbackZone.position().top;
                left = this._feedbackZone.position().left;
                switch (this._feedbackOptions.closeDirection) {
                    case "t":
                        top = "-" + this._feedbackZone.outerHeight() + "px"
                        break;

                    case "r":
                        left = jQuery(window).width() + "px";
                        break;

                    case "l":
                        left = "-" + this._feedbackZone.outerWidth() + "px";
                        break;

                    case "fadeOut":
                        opacity = 0;
                        // CLEM 74236 - Si il y a une durée de passer, on l'utilise car on est en train de fermer le feedback via le timer
                        duration = (options && options.duration) || 50;
                        break;
                }

                this._feedbackZone.velocity({
                    left: left,
                    top: top,
                    opacity: opacity
                },
                    {
                        duration: duration,
                        easing: "easeInCubic",
                        complete: function (me) {
                            return function (elements) {
                                jQuery.each(elements, function (i, element) {
                                    jQuery(element).remove();
                                    me._feedbackZone = null;
                                    me._hideFeedbackInProgress = false;
                                    //On appel le délégué
                                    if (me._onHideFeedbackComplete) {
                                        me._onHideFeedbackComplete.apply(me);
                                        me._onHideFeedbackComplete = null;
                                    }
                                });
                            }
                        }(this)
                    }
                );
            } else {
                this._feedbackZone.fadeOut(500, function (me) {
                    return function () {
                        jQuery(this).css("left", 0);
                        jQuery(this).css("top", 0);
                        me._hideFeedbackInProgress = false;
                        //On appel le délégué
                        if (me._onHideFeedbackComplete) {
                            me._onHideFeedbackComplete.apply(me);
                            me._onHideFeedbackComplete = null;
                        }
                    }
                }(this));
            }
        }
    }
    _ensureFeedbackZone() {
        if (!this._feedbackZone) {
            this._feedbackZone = jQuery("#feedback");
            if (this._feedbackZone.length == 0) {
                var jFeedbackZoneWrapper;
                var jFeedbackZoneContent;
                var jFeedbackZoneColoredArea;
                var closeButton;

                // 1 - Création du div de feedback
                this._feedbackZone = jQuery("<div></div>");
                this._feedbackZone.attr("id", "feedback");

                // 2 - Création du div wrapper
                jFeedbackZoneWrapper = jQuery("<div></div>");
                jFeedbackZoneWrapper.addClass("wrapper");
                this._feedbackZone.append(jFeedbackZoneWrapper);

                // 3 - Création du div de contenu
                jFeedbackZoneContent = jQuery("<div></div>");
                jFeedbackZoneContent.addClass("content");
                jFeedbackZoneWrapper.append(jFeedbackZoneContent);

                // 3 - Création du div représentant la zone colorée
                jFeedbackZoneColoredArea = jQuery("<div></div>");
                jFeedbackZoneColoredArea.addClass("coloredArea");
                jFeedbackZoneContent.append(jFeedbackZoneColoredArea);

                // 4 - Création du div représentant le bouton fermé
                closeButton = jQuery("<div></div>");
                closeButton.addClass("btnClose");
                jFeedbackZoneColoredArea.append(closeButton);

                // 5 - Création du div représentant le message (texte)
                this._feedbackZoneContentText = jQuery("<div></div>");
                this._feedbackZoneContentText.addClass("text");
                jFeedbackZoneColoredArea.append(this._feedbackZoneContentText);

                // On créé la fonction de gestion de la fermeture du feedback
                var fctFeedbackFermeture = function () {
                    // CLEM 74236 - Si on ferme le feedback il faut aussi clear le timer
                    clearTimeout(uiCore._feedbackOptions.timeOut);
                    uiCore._feedbackZone.addClass("closeButtonClick");
                    uiCore.hideFeedback();
                };
                // On associe au bouton 'Fermer' la fonction de fermeture
                closeButton.on("click", fctFeedbackFermeture);
                // On associe au click sur la div feedback la fonction de fermeture
                this._feedbackZone.on("click", fctFeedbackFermeture);
                // On associe à la zone colorée l'annulation de la fermeture
                // La fermeture est donc déclencher quand on click sur la croix 'Fermer' ou en dehors de la zone colorée
                jFeedbackZoneColoredArea.on("click", function (event) {
                    event.stopPropagation();
                });

                jQuery(document.body).prepend(this._feedbackZone);

            }
            this._feedbackZone.removeClass("error");
        }
    }
    _showFeedback(error) {
        /// <summary>
        /// s the specified error.
        /// </summary>
        /// <param name="error">The error.</param>
        /// <returns></returns>
        /// <remarks></remarks>
        /// <history>
        /// <entry mat="[GBAU]" date="10/12/2015" task="113702">Création</entry>
        /// </history>

        if (error) {
            this._feedbackZone.addClass("error");
        } else {
            this._feedbackZone.removeClass("error");
        }

        if (uiCore.isTouchMode()) {
            //MBRO - 22/06/2017 - En mode tactile le feedback apparait simplement
            this._feedbackZone.fadeIn(500);
            // MBRO - 27/08/2018 - En tactile le feedback apparait centré et reste à cette position indépendemment des autres élements de la page (exemple : scroll)
            this._feedbackZone.css("position", "fixed");
        } else {
            var anchor;
            anchor = jQuery(this._feedbackOptions.anchor);
            var offsetTop = anchor.data("offsettop") || 0;

            if (this._motion) {
                var top;
                var left;
                var width;
                var height;


                top = Math.round(anchor.position().top + offsetTop);
                width = this._feedbackZone.outerWidth();
                left = anchor.width() / 2 - width / 2;
                height = this._feedbackZone.outerHeight();

                this._feedbackZone.css("display", "block");

                switch (this._feedbackOptions.openFrom) {
                    case "t":
                        this._feedbackZone.css("top", "-" + height + "px");
                        this._feedbackZone.css("left", left + "px");

                        break;


                    case "l":
                        this._feedbackZone.css("top", top + "px");
                        this._feedbackZone.css("left", "-" + width + "px");

                        break;
                }

                this._feedbackZone.velocity({
                    left: left + "px",
                    top: top + "px",
                },
                    {
                        duration: 1000,
                        easing: [300, 16],
                        complete: function (me) {
                            return function () {
                                me.addMouseHandlersToFeedbackZone();
                            }
                        }(this)
                    }
                );

                // CLEM 74236 - On set un timer sur le feedback
                this._feedbackOptions.timeOut = setTimeout(function () {
                    uiCore.hideFeedback({ duration: uiCore._feedbackOptions.timerDurationFadeOut });
                }, this._feedbackOptions.timerDuration);

            } else {
                this.addMouseHandlersToFeedbackZone();
                this._feedbackZone.position({
                    of: anchor,
                    my: "center top",
                    at: "center top"
                });

                this._feedbackZone.fadeIn(500);
            }
        }
    }
    addMouseHandlersToFeedbackZone() {
        // CLEM 74236 - Si on entre dans le feedback, on clear le timer et on le remet visible
        this._feedbackZone.mouseover(function (me) {
            return function () {
                // Si on a cliqué sur la croix, on n'empeche pas la disparition
                if (!uiCore._feedbackZone.hasClass("closeButtonClick")) {
                    uiCore._feedbackZone.velocity("stop").velocity({ opacity: 1 });
                    clearTimeout(uiCore._feedbackOptions.timeOut);
                }
            };
        }(this));

        // CLEM 74236 - Si on sort du feedback, on set le timer
        this._feedbackZone.mouseout(function () {
            uiCore._feedbackOptions.timeOut = setTimeout(function () {
                uiCore.hideFeedback({ duration: uiCore._feedbackOptions.timerDurationFadeOut });
            }, uiCore._feedbackOptions.timerDuration);
        });
    }
    getSubmit() {
        if (!this.isTop) return this.parent.getSubmit();
        return this._submit;
    }
    setSubmit(value) {
        if (!this.isTop) return this.parent.setSubmit(value);
        this._submit = value;
    }
    getStop() {
        if (!this.isTop) return this.parent.getStop();
        return !this._submit;
    }
    setStop(value) {
        if (!this.isTop) return this.parent.setStop(value);
        this.setSubmit(!value);
    }
    _showRemainingAlerts() {
        var treatment;
        if (this._alertTreatments.length > 0) {
            for (var i = 0; i < this._alertTreatments.length; i++) {
                treatment = this._alertTreatments[i];
                treatment.getEngine()._executeTreatment(treatment, false);
            }
        }
    }
    executeRemainingTreatments() {
        if (!this.isTop) return this.parent.executeRemainingTreatments();
        if (this._uiTreatmentEngine.remainingNotExecutedTreatment()) {
            this._uiTreatmentEngine.execute();
        }
    }
    unblockTreatment(key, result) {
        if (!this.isTop) return this.parent.unblockTreatment(key, result);
        var treatment;
        treatment = this._uiTreatmentEngine.getTreatment(key);
        treatment.getEngine().unblockTreatment(key, result);
    }

    _CheckCompulsoryFieldsOverridable(args) {
        return true;
    }

    _CheckFieldsFormatOverridable(args) {
        if (typeof (jQuery("#Form1").validate({
            errorClass: "validatorError",
            errorElement: "div",
            errorPlacement: function (error, element) {
                element.append(error);
                error.position({
                    of: element,
                    my: "left top",
                    at: "left bottom",
                    collision: "none none"
                });
                error.css("width", element.outerWidth());
            },
            validClass: "validatorSuccess"
        })) !== "undefined") {
            if (jQuery(".validator").length > 0) {
                return jQuery(".validator").valid();
            }
        }
        return true;
    }
    /**
     * Methode CheckField bloquant les uiTreatments
     * @param {Object} args 
     * @returns boolean
     */
    CheckFields(args) {
        this.setSubmit(this.CheckFieldsSync(args));
    }
    /**
     * Methode CheckField renvoyant le résultat du test pour utiliser les promises
     * @param {Object} args 
     * @returns boolean
     */
    CheckFieldsSync(args):boolean {
        let submit = false;
        submit = this._CheckCompulsoryFieldsOverridable(args);
        submit = submit && this._CheckTranslatedFieldsOverridable(args).length === 0;
        submit = submit && this._CheckFieldsFormatOverridable(args);

        return submit;
    }

    /**
     * Vérifie les champs traduits
     * @param args
     * @returns
     */
    _CheckTranslatedFieldsOverridable(args) {
        return [];
    }

    removeFileDragNDropAndPasteOverlay() {
        this.getAjaxFileUploadManager().removeFileDragNDropAndPasteOverlay();
    }
    getFileDragNDropOverlay() {
        return this.getAjaxFileUploadManager().getFileDragNDropOverlay();
    }
    /**
     * Permet de savoir si l'évènement de drag'n'drop concernant un fichier
     * @param {Object} event L'évènement de drag'n'drop
     * @returns boolean
     */
    isFileDragNDrop(event) {
        /// <history>
        /// <entry mat="[GBAU]" date="24/05/2016" bug="74302">Création</entry>
        /// </history>
        let isFile = false;

        if (event.dataTransfer && event.dataTransfer.types.length > 0) {
            let noType = 0;
            while (!isFile && noType < event.dataTransfer.types.length) {
                if (event.dataTransfer.types[noType] == "Files" || event.dataTransfer.types[noType] == "application/x-moz-file") {
                    isFile = true;
                }
                noType++;
            }
        }

        return isFile;
    }
    /**
     * Permet de savoir l'on peut droper un fichier (prend en compte le marquage sur le body ainsi que le faite qu'une popin est ouverte)
     * @returns boolean
     */
    canDropFile(evt) {
        /// <history>
        /// <entry mat="[GBAU]" date="24/05/2016" bug="74238">Création</entry>
        /// </history>

        return this.getAjaxFileUploadManager().canDropFile(evt);
    }
    getAjaxFileUpload(key?) {
        return this.getAjaxFileUploadManager().getAjaxFileUpload(key);
    }
    existsFilesInQueue() {
        return this.getAjaxFileUploadManager().existsFilesInQueue();
    }
    abortAll() {
        return this.getAjaxFileUploadManager().abortAll();
    }
    getAjaxFileUploadManager() {
        var manager = null;

        try {
            manager = window.IsiFW.Components.AjaxFileUpload.IsiAjaxFileUpload.IsiAjaxFileUploadManager.getInstance();
        } catch (e) { }

        return manager;
    }

    /**
     * Désactive le voile d'attente sur le beforeUnload.
     * @param disable
     */
    disableModifWaitStatusAutoOnUnload(disable) {
        this._disableModifWaitStatusAutoOnUnloadOverridable(disable);
    }

    /**
     * Méthode surchargable pour la désactivation du voile d'attente sur le beforeUnload.
     * @param disable
     */
    _disableModifWaitStatusAutoOnUnloadOverridable(disable) {

    }

    /**
     * [LFEN] 04/02/2019
     * @description permet de rendre la fonction modifWaitStatus(visible, wait, codeLibelleStatus) accessible pour normea
     * @param {Boolean} visible
     * @param {Boolean} wait
     * @param {Constante} codeLibelleStatus valeur du WAITING_FAM
     */
    setModifWaitStatus(visible, wait, codeLibelleStatus) {
        this._setModifWaitStatusOverridable(visible, wait, codeLibelleStatus);
    }

    /**
     * [LFEN] 04/02/2019
     * @description permet la surcharge
     * @param {Boolean} visible
     * @param {Boolean} wait
     * @param {Constante} codeLibelleStatus valeur du WAITING_FAM
     */
    _setModifWaitStatusOverridable(visible, wait, codeLibelleStatus) {

    }

    registerAjaxFileUpload(component) {
        this.getAjaxFileUploadManager().registerAjaxFileUpload(component);
    }
    /**
     * Permet de savoir si un élément est un treeview (ou un noeud) ou aucun des deux
     * @param {DomElement|jQuery} element
     * @returns {boolean}
     */
    isTreeView(element) {
        //GBAU - 07/12/2016 - Correction erreur "Cannot read property 'ownerDocument' of undefined" dans le cas ou il n'y a pas de .iTreeView de trouvé
        //HCHA - 16/08/2017 - PB0017091 : Problème lors du glisser-déposer d'un champ du code SQL, celui-ci n'est plus encadré par le caractère "~" dans le corps ou sujet du mail 
        return jQuery(".IsiRichTextTextArea").length > 0 || jQuery(element).hasClass("iTreeView") || (jQuery(".iTreeView").length > 0 && jQuery.contains(jQuery(".iTreeView")[0], element))
    }

    /**
     * Indique si l'écran courant autorise le drag'n'drop d'éléments externe
     * @returns
     */
    screenAllowDrag() {
        return false;
    }

    /**
     * Permet de savoir si un élément est une cible de largage d'un glisser-déposer
     */
    isDropTargetElement(element: HTMLElement): boolean {
        //JBER - 17/04/2020 - Autoriser la propagation du drop sur certains contrôles (sur lesquels il y un écouteur ondrop spécifiquement rajouté qui doit se déclencher)
        return (jQuery(element).closest('.isDropTargetElement').length > 0);
    }

    _configureFileDragNDrop() {
        // GBAU - 21/03/2016 - Blocage d'un drag'n'drop de fichier
        // Cette fonction gère la construction (en partie) du voile de drag'n'drop et bloque le drag'n'drop uniquement sur les écrans ne possédant pas le composant AjaxFileUpload
        // Si le composant AjaxFileUpload est présent, il va prendre le relais
        // Lorsque le body possède la classe css "canDropFile" cela signifie que le composant AjaxFileUpload est présent et donc il faut propager les évènements, lorsqu'il ne possède pas la classe, on peut stopper les évènements
        // Lorsque l'on rentre dans le navigateur avec un fichier en drag, on active un voile avec un message en fonction si l'on peut dropper ou non
        // Les évènements "dragleave" et "dragenter" sont levés même lorsque l'on drag au sein même de la fenêtre, pour eviter un scintillement du voile, on met une lègère temporisation
        // pour ne pas supprimer le voile alors que l'on est toujours en drag
        jQuery(document).ready(function (me) {
            uiCore.getAjaxFileUploadManager().configureFileDragNDrop();
        });
    }
    getAjaxHandlerErrorMessage(error, status) {
        // Dans le cas normal, le retour est un objet JSON
        // Dans le cas ou la taille du fichier dépasse la taille maximum configurer dans IIS (requestFiltering), le retour est gérée par une page d'erreur perso
        // qui renvoie alors du texte (Idem si l'erreur survient tôt dans le HttpHandler)
        var errorMessage = false;
        var errorType = null;
        var errorDetail = false;
        if (typeof error !== "string" && error.data) {
            errorMessage = error.data.ErrorMessage;
            errorType = error.data.errorType;

            if (status == 500 && errorMessage) {
                //Si on a un code 500 et que l'erreur est un objet, alors on a le détail de l'erreur
                errorDetail = errorMessage;
            }
        } else if (typeof error !== "string" && error.error) {
            errorMessage = error.error.ErrorMessage;
            errorType = error.error.ErrorType;
        } else {
            errorMessage = error;
            errorType = error;
        }

        if (errorType == "MissingContext") {
            errorType = "Forbidden";
        }

        if (errorType == "ServerError" || errorType == "UnhandledError") {
            if (!errorDetail) {
                //Si on n'a pas de detail, on met un détail générique
                errorDetail = uiCore.getMessage("UICORE", "Ajax" + errorType).IsiLabel.replace("{{statusCode}}", status);
            }
            errorMessage = uiCore.getMessage("Err", "ERROROCCURED").IsiLabel.replace("$i", errorDetail);
        } else if (errorType == "Forbidden") {
            errorMessage = uiCore.getMessage("UICORE", "Ajax" + errorType).IsiLabel;
        }

        return errorMessage;
    }
    getClient() {
        if (!this.isTop) return this.parent.getClient();
        //if (!this._client) {
        //    this._client = this.detectClient();
        //}
        return this._client;
    }
    setClient(value) {
        this._client = value;

        if (value && typeof (value.isTablet) === 'undefined') {
            this._ensureClient(value);
        }

        if (value) {
            updateDeviceInfos(value.IsiWidth.value, value.IsiHeight.value, value.RWDMode, value.RWDOrientation, this.browser.isMobile());
        }
    }
    _ensureClient(dtoClient) {
        dtoClient.isTablet = function () {
            return this.RWDMode == IsiRWDMode.Tablet;
        }

        dtoClient.isPhone = function () {
            return this.RWDMode == IsiRWDMode.Phone;
        }

        dtoClient.isHTablet = function () {
            return this.RWDMode == IsiRWDMode.Tablet && this.RWDOrientation == IsiRWDOrientation.Landscape;
        }

        dtoClient.isVTablet = function () {
            return this.RWDMode == IsiRWDMode.Tablet && this.RWDOrientation == IsiRWDOrientation.Portrait;
        }

        dtoClient.isHPhone = function () {
            return this.RWDMode == IsiRWDMode.Phone && this.RWDOrientation == IsiRWDOrientation.Landscape;
        }

        dtoClient.isVPhone = function () {
            return this.RWDMode == IsiRWDMode.Phone && this.RWDOrientation == IsiRWDOrientation.Portrait;
        }
    }
    /**
     * Permet de detecter le client (device, orientation, ...)
     * @param {IIsiDtoClient} dtoClient
     * @return {IIsiDtoClient} Un dto représentant le client
     */
    detectClient(dtoClient, orientationChange?) {

        dtoClient.IsiWidth.value = jQuery(window).width();
        dtoClient.IsiHeight.value = jQuery(window).height();

        dtoClient.IsiProtocol = window.location.protocol;
        dtoClient.IsiHostname = window.location.hostname;

        if (window.location.port == "") {
            var port;
            port = 80;
            if (window.location.protocol == "https:") {
                port = 443;
            }
            dtoClient.IsiPort = port;
        } else {
            dtoClient.IsiPort = window.location.port;
        }

        if (typeof (Modernizr) !== "undefined") {
            dtoClient.InputDate = Modernizr.inputtypes.date && (!this.browser.isChrome() || this.browser.isChromeMobile());
        }

        var isMobile;
        var width, widthForDevice;
        var height;
        var previousRWDLength;
        var previousOrientation;
        var newRWDLength;
        var newOrientation;
        let newRWDOrientation;

        isMobile = this.browser.isMobile();

        if (isMobile) {
            width = screen.width;
            height = screen.height;
        } else {
            width = jQuery(window).width();
            height = jQuery(window).height();
        }
        //Identification de l'orientation, afin de bien gérer la taille des tablette apple
        if (window.matchMedia("(orientation: portrait)").matches) {
            newRWDOrientation = IsiRWDOrientation.Portrait;
        } else {
            newRWDOrientation = IsiRWDOrientation.Landscape;
        }
        // SOOZ - 01/08/2017 - On retient la taille précédente et l'orientation précédente.
        if (dtoClient.RWDLength == IsiRWDLength.Small) {
            previousRWDLength = "small";
        } else if (dtoClient.RWDLength == IsiRWDLength.Medium) {
            previousRWDLength = "medium";
        } else if (dtoClient.RWDLength == IsiRWDLength.Large) {
            previousRWDLength = "large";
        }

        dtoClient.RWDLength = IsiRWDLength.Large;
        // YLAR 31/07/2017 : On conserve les propriétés détectés au premier chargement.
        if (this.isRWDPhone()) {
            // Si le mode mobile a déjà détecté, on reste dans ce mode
            dtoClient.RWDMode = IsiRWDMode.Phone;
        }
        else if (this.isRWDTablet()) {
            // Si le mode tablet a déjà détecté, on reste dans ce mode
            dtoClient.RWDMode = IsiRWDMode.Tablet;
            widthForDevice = width;
            // YLAR 19/06/2017 DEV134799 : Sur safari, on prends la taille du dtoclient, car la width ne change pas en fonction de l'orientation
            if (IsiBrowser.isSafari) {
                if (newRWDOrientation === IsiRWDOrientation.Portrait) {
                    widthForDevice = height;
                }
            }
            if (widthForDevice < this.ruptureMoyen()) {
                dtoClient.RWDLength = IsiRWDLength.Small;
                newRWDLength = "small";
            } else if (widthForDevice < this.ruptureGrand()) {
                dtoClient.RWDLength = IsiRWDLength.Medium;
                newRWDLength = "medium";
            } else {
                dtoClient.RWDLength = IsiRWDLength.Large;
                newRWDLength = "large";
            }
        }
        else if (width > 0) {
            if (isMobile) {
                if (width < this.rupturePetit()) {
                    dtoClient.RWDMode = IsiRWDMode.Phone;
                } else {
                    if (height < 550) {
                        dtoClient.RWDMode = IsiRWDMode.Phone;
                    } else {
                        dtoClient.RWDMode = IsiRWDMode.Tablet;
                        widthForDevice = width;
                        // YLAR 19/06/2017 DEV134799 : Sur safari, on prends la taille du dtoclient, car la width ne change pas en fonction de l'orientation
                        if (IsiBrowser.isSafari) {
                            widthForDevice = dtoClient.IsiWidth.value;
                        }
                        if (widthForDevice < this.ruptureMoyen()) {
                            dtoClient.RWDLength = IsiRWDLength.Small;
                            newRWDLength = "small";
                        } else if (widthForDevice < this.ruptureGrand()) {
                            dtoClient.RWDLength = IsiRWDLength.Medium;
                            newRWDLength = "medium";
                        } else {
                            dtoClient.RWDLength = IsiRWDLength.Large;
                            newRWDLength = "large";
                        }
                    }
                }
            } else {
                if (this.isDesktopTouchMode()) {
                    //Tactile en mode desktop, on force en tablette
                    dtoClient.RWDMode = IsiRWDMode.Tablet;
                    widthForDevice = width;
                    // YLAR 19/06/2017 DEV134799 : Dans le cas d'un affichage landscape, les tailles sont inversés
                    if (dtoClient.IsiWidth.value > dtoClient.IsiHeight.value) {
                        widthForDevice = height;
                    }
                    if (widthForDevice < this.ruptureMoyen()) {
                        dtoClient.RWDLength = IsiRWDLength.Small;
                        newRWDLength = "small";
                    } else if (widthForDevice < this.ruptureGrand()) {
                        dtoClient.RWDLength = IsiRWDLength.Medium;
                        newRWDLength = "medium";
                    } else {
                        dtoClient.RWDLength = IsiRWDLength.Large;
                        newRWDLength = "large";
                    }
                } else {
                    //if (width < 480) {
                    //    dtoClient.RWDMode = 2;
                    //} else if (height < 700) {
                    //    dtoClient.RWDMode = 1;
                    //} else {
                    dtoClient.RWDMode = IsiRWDMode.Desktop;
                    //}
                }

            }
        }

        if (orientationChange) {
            if (dtoClient.RWDOrientation == IsiRWDOrientation.Landscape) {
                previousOrientation = "landscape";
                newOrientation = "portrait";
            } else if (dtoClient.RWDOrientation == IsiRWDOrientation.Portrait) {
                previousOrientation = "portrait";
                newOrientation = "landscape";
            }
            jQuery("body").removeClass(previousOrientation).addClass(newOrientation);
        } else {
            // Rectification pour safari pour avoir le bon mode
            if (newRWDOrientation === IsiRWDOrientation.Landscape) {
                newOrientation = "landscape";
            } else {
                newOrientation = "portrait";
            }

            jQuery("body").addClass(newOrientation);
        }
        dtoClient.RWDOrientation = newRWDOrientation;
        // SOOZ - 01/08/2017 - T138262 - Si on est en tablette et qu'on a retenue une taille précédente
        //                               On  l'écrase avec la nouvelle, sinon on ajoute juste la nouvelle taille.
        if (dtoClient.RWDMode == IsiRWDMode.Tablet) {
            if (previousRWDLength) {
                jQuery("body").removeClass(previousRWDLength).addClass(newRWDLength);
            } else {
                jQuery("body").addClass(newRWDLength);
            }
        }

        // MBRO - 28/05/2018 - DemoOceane - Détermination du navigateur et sauvegarde dans le DtoClient
        if (this.browser.isIE()) {
            dtoClient.WebBrowser = WebBrowser.InternetExplorer;
        } else if (this.browser.isEdge()) {
            dtoClient.WebBrowser = WebBrowser.Edge;
        } else if (this.browser.isFirefox()) {
            dtoClient.WebBrowser = WebBrowser.Firefox;
        } else if (this.browser.isChrome()) {
            dtoClient.WebBrowser = WebBrowser.Chrome;
        } else if (this.browser.isSafari()) {
            dtoClient.WebBrowser = WebBrowser.Safari;
        }

        updateDeviceInfos(dtoClient.IsiWidth.value, dtoClient.IsiHeight.value, dtoClient.RWDMode, dtoClient.RWDOrientation, isMobile);

        return dtoClient;
    }
    /**
     * On est en portrait ?
     * @return {Boolean} true si on est en portrait sinon false
     */
    isPortrait() {
        if (!this.isTop) return this.parent.isPortrait();
        return jQuery("body").hasClass("portrait");
    }
    /**
    * On est en paysage ?
    * @return {Boolean} true si on est en paysage sinon false
    */
    isLandscape() {
        if (!this.isTop) return this.parent.isLandscape();
        return jQuery("body").hasClass("landscape");
    }
    /**
    * On est dans une popin ?
    * @return {Boolean} true si on est dans une popin sinon false
    */
    isPopin(): boolean {
        return this.isPopinOverridable();
    }
    protected isPopinOverridable(): boolean {
        if (!this.isTop) return this.parent.isPopin();
        return _IsiIsPopin();
    }
    isMobileEnabled() {
        if (!this.isTop) return this.parent.isMobileEnabled();
        /// <history>
        /// <entry mat="MAXB" date="12/06/2017" task="">Création</entry>
        /// </history>
        return this._options.enableMobile;
    }
    rupturePetit() {
        if (!this.isTop) return this.parent.rupturePetit();
        /// <history>
        /// <entry mat="MAXB" date="26/06/2017" task="">Création</entry>
        /// </history>
        return this._options.rupturePetit;
    }
    ruptureMoyen() {
        if (!this.isTop) return this.parent.ruptureMoyen();
        /// <history>
        /// <entry mat="MAXB" date="26/06/2017" task="">Création</entry>
        /// </history>
        return this._options.ruptureMoyen;
    }
    ruptureGrand() {
        if (!this.isTop) return this.parent.ruptureGrand();
        /// <history>
        /// <entry mat="MAXB" date="26/06/2017" task="">Création</entry>
        /// </history>
        return this._options.ruptureGrand;
    }
    /*
     * Fonction permettant au chargement les points de rupture Bootstrap par défaut (ruptureGrand)
     */
    _specificPageSizeOverridable() {

    }
    /**
     * Mode responsive ?
     * @return {Boolean} true si on est en mode responsive sinon false
     */
    isRWD() {
        if (!this.isTop) return this.parent.isRWD();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isRWD === null) {
            this._isRWD = jQuery("body").hasClass("rwd");
        }
        return this._isRWD;
    }
    /**
     * Mode tablette ou téléphone ?
     * @return {Boolean} true si on est en mode tablette ou téléphone sinon false
     */
    isRWDMobile() {
        if (!this.isTop) return this.parent.isRWDMobile();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isRWDMobile === null) {
            this._isRWDMobile = this.isRWD() && jQuery("body").hasClass("mobile");
        }
        return this._isRWDMobile;
    }
    /**
    * Mode tablette ?
    * @return {Boolean} true si on est en mode tablette sinon false
    */
    isRWDTablet() {
        if (!this.isTop) return this.parent.isRWDTablet();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isRWDTablet === null) {
            this._isRWDTablet = this.isRWDMobile() && jQuery("body").hasClass("tablet");
        }
        return this._isRWDTablet;
    }
    /**
    * Mode phone, smartphone ?
    * @return {Boolean} true si on est en mode phone sinon false
    */
    isRWDPhone() {
        if (!this.isTop) return this.parent.isRWDPhone();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isRWDPhone === null) {
            this._isRWDPhone = this.isRWDMobile() && jQuery("body").hasClass("phone");
        }
        return this._isRWDPhone;
    }
    /**
     * Mode tablette portrait ou téléphone ?
     * @return {Boolean} true si on est en mode tablette portrait ou téléphone sinon false
     */
    isRWDVTabletOrPhone() {
        if (!this.isTop) return this.parent.isRWDVTabletOrPhone();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isRWDVTabletOrPhone === null) {
            this._isRWDVTabletOrPhone = this.isRWDMobile() && (jQuery("body").hasClass("phone") || (jQuery("body").hasClass("tablet portrait")));
        }
        return this._isRWDVTabletOrPhone;
    }
    /**
     * Mode desktop tactile ?
     * @return {Boolean} true si on est en mode desktop tactile sinon false
     */
    isDesktopTouchMode() {
        if (!this.isTop) return this.parent.isDesktopTouchMode();
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127806">Création</entry>
        /// </history>
        if (this._isDesktopTouchMode === null) {
            this._isDesktopTouchMode = jQuery("body").hasClass("desktopTouchMode");
        }
        return this._isDesktopTouchMode;
    }
    isTouchMode() {
        if (!this.isTop) return this.parent.isTouchMode();
        return this.isRWDMobile() || this.isDesktopTouchMode();
    }

    /**
    * Transforme une unit VB en valeur css
    * @return {string} valeur en css de la unit
    */
    unitToCSS(unit) {
        /// <history>
        /// <entry mat="CLEM" date="04/07/2017" task="">Création</entry>
        /// </history>
        return unit.value + UnitTypeAsString[unit.unit];
    }
    _addEventHandler(key, handler) {
        this._events.addHandler(key, handler);
    }
    _removeEventHandler(key, handler) {
        if (this._unload === false) {
            this._events.removeHandler(key, handler);
        }
    }
    _raiseEvent(key, args) {
        var handler = this._events.getHandler(key);
        if (handler) handler(this, args);
        return;
    }
    /**
     * Permet de s'abonner à l'évènement levé lorsque l'orientation à changé
     * @param {Function} handler La fonction qui sera appelée lorsque l'orientation à changé
     */
    add_orientationChanged(handler) {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// </history>
        this._addEventHandler("orientationChanged", handler);
    }
    /**
     * Permet de supprimer l'abonnement à l'évènement 
     * @param {Function} handler La fonction à désabonner
     */
    remove_orientationChanged(handler) {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// </history>
        this._removeEventHandler("orientationChanged", handler);
    }
    /**
     * Appelée lorsque l'orientation à changé
     * @param {Object} sender L'initiateur de l'évènement
     * @param {Object} args Les données associées à l'évènement
     * @returns {Boolean} 
     */
    _orientationChanged(sender?, args?) {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// </history>
        args = args || {};

        this._client = uiCore.detectClient(this.getClient(), true);
        args.client = this._client;

        this._raiseEvent("orientationChanged", args);
        // YLAR 19/06/2017 DEV134799 : On transmet les nouvelles propriétés du dtoClient.
        uiCore.flushDtoClient();
        return true;
    }
    /**
     * Permet de s'abonner à l'évènement levé lorsque la taille de la fenetre change
     * @param {Function} handler La fonction qui sera appelée lorsque la fenetre change
     */
    add_sizeChanged(handler) {
        /// <history>
        /// <entry mat="CLEM" date="20/09/2017" task="">Création</entry>
        /// </history>
        this._addEventHandler("resize", handler);
    }
    /**
     * Permet de supprimer l'abonnement à l'évènement 
     * @param {Function} handler La fonction à désabonner
     */
    remove_sizeChanged(handler) {
        /// <history>
        /// <entry mat="CLEM" date="20/09/2017" task="">Création</entry>
        /// </history>
        this._removeEventHandler("resize", handler);
    }
    /**
     * Appelée lorsque la taille de la fenêtre à changé
     * @param {Object} sender L'initiateur de l'évènement
     * @param {Object} args Les données associées à l'évènement
     * @returns {Boolean} 
     */
    _sizeChanged(sender?, args?) {
        /// <history>
        /// <entry mat="CLEM" date="20/09/2017" task="">Création</entry>
        /// </history>
        // YLAR 14/03/2019 DYSF86884 : On utilise la taille calculé dans le handleSizeChanged plutot que celle dans le DTOClient.
        if (this._cachedHeight !== undefined && this._cachedWidth !== undefined) {
            // Si les dimensions sont définis
            if (this._cachedHeight <= this._cachedWidth) {
                // Si la hauteur est inférieur ou égale à la largeur on met la classe 'landscape' sur le body
                jQuery("body").removeClass("portrait").addClass("landscape");
            } else {
                // Sinon on met la classe 'portrait' sur le body
                jQuery("body").removeClass("landscape").addClass("portrait");
            }
        }

        // 138075 - on cable les options de l'appli sur les classes iws de bootstrap
        //DYSF88304 : Le point de rupture fait partie de la taille au dessus.
        let viewports = "";
        if (this._cachedWidth >= this.rupturePetit()) {
            viewports += " rupturePetit";
        }
        if (this._cachedWidth >= this.ruptureMoyen()) {
            viewports += " ruptureMoyen";
        }
        if (this._cachedWidth >= this.ruptureGrand()) {
            viewports += " ruptureGrand";
        }

        jQuery("body").removeClass("rupturePetit ruptureMoyen ruptureGrand").addClass(viewports);

        // Soulève 'manuellement' l'évènement resize
        this._raiseEvent("resize", args);
    }
    /**
     * Appliquer manuellement le changement de taille de la fenêtre (en cas de modification des valeurs du IsiDtoClient après le chargement par exemple)
     */
    sizeChange() {
        this._sizeChanged();
    }
    /**
    * Permet de s'abonner à l'évènement levé lorsque l'onglet du navigateur change de visibilité 
    * @param {Function} handler La fonction qui sera appelée lorsque la visibilité change
    */
    add_visibilityChanged(handler: Function): void {
        /// <history>
        /// <entry mat="JBER" date="20/04/2022" task="">Création</entry>
        /// </history>
        this._addEventHandler("visibilitychange", handler);
    }
    /**
     * Permet de supprimer l'abonnement à l'évènement 
     * @param {Function} handler La fonction de laquelle se désabonner
     */
    remove_visibilityChanged(handler: Function): void {
        /// <history>
        /// <entry mat="JBER" date="20/04/2022" task="">Création</entry>
        /// </history>
        this._removeEventHandler("visibilitychange", handler);
    }
    /**
     * Appelée lorsque l'onglet du navigateur a changé de visibilité
     * @param {Object} sender L'initiateur de l'évènement
     * @param {Object} args Les données associées à l'évènement
     */
    _visibilityChanged(sender?: any, args?: any): void {
        /// <history>
        /// <entry mat="JBER" date="20/04/2022" task="">Création</entry>
        /// </history>

        // Levée de l'événement visibilitychange (pour code spécifique)
        this._raiseEvent("visibilitychange", args);
    }
    /**
     * Initialisation
     * @returns {Boolean} 
     */
    initialize() {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="129504">Création</entry>
        /// </history>
        if (this.isTop) {
            this._graphvizReport.initialize();

            this._deserializeDtoClient();

            if (this._detectClient) {
                if (!this._client || !this._client.IsiHostname) {
                    this._client = this.detectClient(this.getClient());
                }
            } else {
                if (window !== window.parent && typeof (window.parent.uiCore) !== 'undefined') {
                    this._client = (<TFinal>window.parent.uiCore).getClient();
                }
            }

            if (typeof (window.IsiTranslations) !== "undefined") {
                this.setSessionStorageItem("IsiTranslations", window.IsiTranslations);
            }
        }

        if (jQuery("#IsiComponentManager").exists()) {
            this._componentManager = this.createComponentManager(jQuery("#IsiComponentManager"));
            this._componentFactory = new IsiComponentFactory(this._componentManager);
        }

        this.createController(jQuery("#IsiController"));

        window.IsiPageRequestManager = new IsiPageRequestManager();
        window.DateHelper = DateHelper
        
        this._formValidateManager = new IsiFormValidateManager(this.getOptions().formValidateManagerSettings);
        if (window.clientState) {
            this._state = IsiDtoUIClientState.fromJS(clientState);
        }

        //if (jQuery("#IsiComponentManager").exists()) {
        //    require(["_IsiComponentManager_Create"], function (fct) {
        //        fct();
        //    });
        //}
        if (this.isTop) {

            this._handleOrientationChange();
            this._handlePullDownRefresh();
            this._handleBackButton();
            this._handleScrollButton();
            this._handleSizeChange();
            this._handleVisibilityChange();

            //Sur mobile le scroll sur les devices n'est pas fluide (lorsqu'on passe sur les graphes par exemple)
            this._handleMobileScrollBar();

            // Fonction permettant de surcharger les points de ruptures appliquées au chargement de la page
            this._specificPageSizeOverridable();

            // appel testConnection
            if (!this.isHomepage()) {
                setInterval(function (me) {
                    return function () {
                        me._testConnection();
                    }
                }(this), 10000);
            }

            // YLAR 28/11/2017 : On définit que la fancybox ne gère pas l'historique de l'application.
            jQuery.fancybox.defaults.hash = false;

            //GBAU - 27/03/2018 - DEV141807 - Gestion de la navigation backward/forward + rafraichir
            this._userJustDoHistoryBack = this.getSessionStorageItem("userGoBack") === "true";
            this.setSessionStorageItem("userGoBack", false);

            this.initializeOverridable();

            if (document.readyState == 'interactive' || document.readyState == 'complete') {
                this.domContentLoadedComplete();
            } else {
                document.addEventListener("DOMContentLoaded", function (me) {
                    return function () {
                        me.domContentLoadedComplete();
                    }
                }(this));
            }
        }

        this.popinTabFocusInit(); // Gestion de la tabulation dans les popins

        if (this._componentManager) {
            //Doit être fait après que le controller ait été créé car cela va déclencher la création des composants
            this.registerComponentManager(this._componentManager);
        }

        return true;
    }
    /**
     * set un délégué appelé avant le asyncPostBack
     * */
    public setBeforeAsyncPostBackDlg(dlg: () => void) {
        this.pageRequestManager.setBeforeAsyncPostBackDlg(dlg);
    }
    protected initializeOverridable() {

    }

    // Cette fonction gere les tabulations dans les popins
    popinTabFocusInit(): void {
        //GBAU RWD'
        if (jQuery("body").hasClass("glob") || jQuery("body").hasClass("globLoading")) {
            this.initTabulation = function () {
                if (jQuery('[tabulation]').length == 0) {
                    var elems = jQuery(':tabbable');
                    //on tri les élements tabulable par tabindex
                    elems.sort(function (a, b) {
                        return a.getAttribute("tabindex") - b.getAttribute("tabindex");
                    });

                    var elemDeb = elems.first();
                    var elemFin = elems.last();
                    var tabIndex = '2';

                    if (elemFin && elemFin != elemDeb) {
                        // Ajout de l'attribut tabulation 2 sur le dernier bouton de la popin
                        // si tabulation sur cet element, on met le focus sur le premier element
                        jQuery(elemFin).attr('tabulation', '2');
                        jQuery(elemFin).keydown(function (evt) {
                            if (evt.which == 9 && !evt.shiftKey) {
                                evt.preventDefault();
                                jQuery("[tabulation=1]").focus();
                            }
                        });
                    } else {
                        // cas ou il y a un seule element tabulable dans la popin : l'element suivant est lui-meme
                        tabIndex = '1';
                    }

                    if (elemDeb) {
                        // Ajout de l'attribut tabulation 1 sur le premier element tabulable de la popin
                        // Si shift tab sur cet element alors le focus est mis sur le dernier element de la popin.
                        jQuery(elemDeb).attr('tabulation', '1');
                        jQuery(elemDeb).keydown(function (evt) {
                            if (evt.shiftKey && evt.which == 9) {
                                evt.preventDefault();
                                jQuery("[tabulation=" + tabIndex + "]").focus();
                            }
                        });
                    }
                }
            }


            // Le focus est mis sur le premier element tabulable de la popin
            this.setFocusOnPopin = () => {
                jQuery(fancyboxIframeSelector).trigger("focus");
                this.initTabulation();
                const elem = jQuery("[tabulation=1]");
                if (elem.length > 0) {
                    elem.trigger("focus");
                }
            }

            window.addEventListener("load", () => {
                this.setFocusOnPopin();
            });
        } else {
            // Gestion de l'exterieur de la popin
            // S'il n'existe pas de popin alors sur le focus de la page (formulaire) on essaie de mettre le focus sur la popin s'il y en a une
            jQuery(window).on("focus", function () {
                trysetFocusOnPopin();
            });

        }
    }

    /**
     * Créé un IsiComponentManager en se basant sur l'élément JQuery passé en paramètre
     * @param element
     */
    createComponentManager(element: JQuery) {
        let componentManager: IsiComponentManager = null;
        if (element.exists() && this.getOptions().componentManager) {

            componentManager = IsiComponentManager.IsiCreate(this.getOptions().componentManager.id, null, this.getOptions().componentManager.props, element);
            window.IsiComponentManager = componentManager;

            //if (typeof window.__webpack_require__ !== "undefined") {
            if (!__webpack_public_path__) {
                __webpack_public_path__ = componentManager.webpackPublicPath;
            }
        }
        return componentManager;
    }

    /**
     * Créé un IsiPageController en se basant sur l'élément JQuery passé en paramètre
     * @param element
     */
    createController(element: JQuery) {
        if (element.exists() && this.componentFactory != undefined) {
            this.componentFactory.createComponent(IsiPageController, this.getOptions().controller.id, null, this.getOptions().controller.props, element);
        }
    }

    _deserializeDtoClient() {
        this._jihdDtoClient = jQuery("#ihdDtoClient");
        if (this._jihdDtoClient.length && this._jihdDtoClient.val() != "") {
            this._client = jQuery.parseJSON(this._jihdDtoClient.val());

            this._ensureClient(this._client);
        }
    }
    flushDtoClient() {
        // si on a un controle 
        if (this._detectClient && this._jihdDtoClient) {
            // si on a un objet
            // LBRI - 2013.02.06 - [DEV:62442] : il arrive (a cause du treeview.nodClick) que le flush
            // soit lance une fois avant le deserializeDtoClientIWS. Du coup, on ne supprime pas la 
            // valeur du dtoClient s'il n'y a pas de dtoClientIws.
            if (this._client) {
                this._jihdDtoClient.val(jQuery.toJSON(this._client));
            }
        }
    }
    /**
     * Traitement de l'évènement de changement d'orientation
     */
    _handleOrientationChange() {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// </history>
        if (this.browser.isMobile() || this.isDesktopTouchMode()) {

            // Listen for orientation changes
            jQuery(window).on("orientationchange", function (me) {
                return function () {
                    me._orientationChanged();
                }

            }(this));

        }
    }
    /**
   * Traitement du scroll non fluide en mobile
   */
    _handleMobileScrollBar() {
        /// <history>
        /// <entry mat="MAXB" date="23/10/2017" task="">Création</entry>
        /// </history>
        var timer;

        jQuery(window).on('scroll', function () {
            jQuery("body").addClass("scrolling");
            timer = clearTimeout(timer);
            timer = setTimeout(function () { jQuery("body").removeClass("scrolling"); }, 50);
        });
    }
    /**
   * Traitement du resize
   */
    _handleSizeChange() {
        /// <history>
        /// <entry mat="CLEM" date="19/09/2017" task="">Création</entry>
        /// </history>
        /// Modification MAXB le resize de la fenetre est lancé au scroll sur mobile
        this._cachedWidth = jQuery(window).width();
        this._cachedHeight = jQuery(window).height();

        window.addEventListener("resize", function (me) {
            return function () {
                const newWidth = jQuery(window).width();
                const newHeight = jQuery(window).height();
                
                if (newWidth !== me._cachedWidth || newHeight !== me._cachedHeight) {
                    // pour les perfs et la robustesse, on évite de faire getClient(), si rien n'a changé
                    const cli = me.getClient();
                    if (cli && cli.RWDMode !== IsiRWDMode.Phone) {                       
                        me._cachedWidth = newWidth;
                        me._cachedHeight = newHeight;
                        me._sizeChanged();
                    }
                }
            }
        }(this));
    }
    /**
    * Gestion du changement de visibilité de l'onglet du navigateur (onglet devenant visible ou non-visible)
    */
    _handleVisibilityChange(): void {
        /// <history>
        /// <entry mat="JBER" date="20/04/2022" task="">Création</entry>
        /// </history>

        window.addEventListener("visibilitychange", (): void => {
            this._visibilityChanged();
        });
    }
    _handleScrollButton(functionsOnClick?: [Function], scrollEventToListen?: string) {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// </history>
        jQuery(document).ready(function (me) {
            return function () {
                if (!me._scrollButtonOptions.disabled) {
                    me.whenComponentManagerFound(function () {
                        me.pageUpBtn = window.IsiFW.Components.Button.IsiScrollButton.IsiCreate("IsiScrollButtonPage",
                            jQuery(me._scrollButtonOptions.divContainer)[0],
                            {
                                Dto: window.IsiFW.Components.Button.IsiScrollButton.createInstanceOfEmptyDto({
                                    containerID: me._scrollButtonOptions.containerID,
                                    scrollableContainer: me._scrollButtonOptions.scrollableContainer
                                })
                            });
                        if (functionsOnClick) {
                            functionsOnClick.forEach((fct) => {
                                me.pageUpBtn.addFunctionToDoOnClick(fct);
                            })
                        }
                        if (scrollEventToListen) {
                            me.pageUpBtn.changeScrollEvent(scrollEventToListen);
                        }
                    });
                }
            }
        }(this));
    }

    /**
     * Obtient le IsiScrollButtonPage
     * @returns
     */
    getScrollButton(): any {
        return this.componentManager.getComponent("IsiScrollButtonPage");
    }

    /**
     * Reconstruit le bouton de scroll (IsiScrollButtonPage)
     */
    reconstructScrollButton(functionsOnClick?: [Function], scrollEventToListen?: string) {
        const oldScrollBtn = this.getScrollButton(); 

        if (oldScrollBtn) {
            oldScrollBtn.removeScrollAndDispose();
        }

        this._handleScrollButton(functionsOnClick, scrollEventToListen);

    }

    /**
     * Traitement de refresh déclenchée via un geste touch (chrome uniquement pour le moment)
     */
    _handlePullDownRefresh() {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="127805">Création</entry>
        /// <entry mat="JHAL" date="09/03/2020" dysf="89682">En appliquant le style overscroll-behavior à contain, on bloque le pull to refresh sans impacter le scroll</entry>
        /// </history>

        // Si on est sous Chrome Mobile, alors on bloque le PullDownToRefresh
        if (this.browser.isChromeMobile()) {
            (<any>document.body.style).overscrollBehavior = "contain";
        }


    }
    /**
     * Traitement du bouton back du navigateur
     */
    _handleBackButton() {
        /// <history>
        /// <entry mat="GBAU" date="21/11/2016" task="129504">Création</entry>
        /// </history>
        if (window.history && window.history.pushState) {
            //GBAU - 27/03/2018 - DEV141807 - Gestion de la navigation backward/forward + rafraichir
            if (this.getOptions().allowHistoryBack) {
                jQuery(window).on('hashchange', function (me) {
                    return function (e) {
                        //Dans le cas ou c'est simplement un hashchange, on ne fait pas un go back
                        me._cancelNextHistoryPopState = true;
                        if (me._historyBackTimeout) {
                            clearTimeout(me._historyBackTimeout);
                        }
                    }
                }(this));
            }

            jQuery(window).on('popstate', function (me) {
                return function (e) {
                    if (me.getOptions().allowHistoryBack) {
                        //La navigation par le backward/forward navigateur est activé
                        if (!me._cancelNextHistoryPopState) {
                            //Dans le cas ou c'est simplement le hash qui change, on ne déclenche pas le back du navigateur pour aller ver la page précédente
                            //Pour cela, on met un setTimeout pour pouvoir détecter l'évent hashchange qui est déclenché après et donc trop tard
                            me._historyBackTimeout = window.setTimeout(function () {
                                if (!uiCore._cancelNextHistoryPopState) {
                                    uiCore.setSessionStorageItem("userGoBack", true);
                                    window.history.back();
                                }
                            });
                        }
                        me._cancelNextHistoryPopState = false;
                    } else {
                        //Comme avant, on ajoute une ligne d'historique pour annuler le back du navigateur
                        window.history.pushState('newforward', null, null);
                        me._onBackButtonCallback();
                    }
                }
            }(this));
            //GBAU - 27/03/2018 - DEV141807 - Gestion de la navigation backward/forward + rafraichir
            if (!this.getOptions().allowHistoryBack) {
                //Comme avant, on ajoute une ligne d'historique pour annuler le back du navigateur
                try {
                    window.history.pushState('forward', null, null);
                } catch (ex) {
                }
            } else {
                history.replaceState(null, document.title, location.href);
            }

        }
    }
    reloadPage() {
        this._reloadPageOverridable();
    }
    _reloadPageOverridable() {
    }

    /**
     * Ouvre la popin de traduction simple pour un web part.
     * @param wpObj
     */
    public openSimpleTranslatePopinForWebPartOveridable(wpObj: any) {
    }

    // Cette fontion gere le test de la perte connection
    _testConnection() {
        var path = this.testConnexionUrl();
        if (this.canTestConnection()) {
            jQuery.ajax({
                url: path,
                type: 'HEAD',
                timeout: 5000,
                dataType: 'text',
                cache: false
            }).done(
                function (me) {
                    return function () {
                        me._treatConnectionLoss(true);
                    }
                }(this))
                .fail(
                    function (me) {
                        return function () {
                            me._treatConnectionLoss(false);
                        }
                    }(this));
        }
    }
    _treatConnectionLoss(online) {
        if (online) {
            jQuery("body").removeClass('offline');
        } else {
            let jOffLine = jQuery("#divOffline");
            if (jOffLine.length == 0) {
                jQuery("body").addClass('offline').prepend("<div id='divOffline'><i tp='1' class='fi fi-perte-connexion'></i></div>");
            } else {
                jQuery("body").addClass('offline');
            }
            jQuery("#divOffline").focus();
        }
    }
    isHomepage() {
        return this._isHomepageOverridable();
    }
    _isHomepageOverridable() {
        return false;
    }
    /**
     * Retourne l'url utilisé pour effectuer le test de disponibilité du sever
     * @returns la dite url
     */
    testConnexionUrl() {
        return this._testConnexionUrlOverridable();
    }
    /**
     *  Méthode à surcharger pour définir l'url utilisé 
     *  pour effectuer le test de disponibilité du sever
     * @returns la dite url
     */
    _testConnexionUrlOverridable() {
        return '/';
    }
    canTestConnection() {
        return !this.isHomepage() && this._canTestConnectionOverridable();
    }
    _canTestConnectionOverridable() {
        return true;
    }
    /**
     * Retourne l'identifiant du composant Popin.
     */
    _getPopInId() {
        return this._getPopInCmpIdOverriadable();
    }
    /**
     * Retourne l'identifiant du composant Popin surchargeable dans les produits.
     */
    _getPopInCmpIdOverriadable() {
        return 'popin'
    }
    /**
     * Permet de récupérer le componentManager
     */
    registerComponentManager(componentManager) {
        if (!this._componentManager) {
            this._componentManager = componentManager;
        }
        this._componentManagerFound(this._componentManager);
    }
    /**
     * Méthode appelée une fois le IsiComponentManager trouvé
     */
    _componentManagerFound(componentManager) {
        this._componentManagerFoundOverridable(componentManager);

        this._createComponents();

        // récupération du composant popin
        if (uiCore.popinCmp == null) {
            componentManager.whenComponentFound(uiCore._getPopInId(), function (cp) {
                uiCore.popinCmp = cp;
            });
        }

        //Si il a des callback d'enregistrés, on les appele
        if (this._whenComponentManagerFoundHandlers.length) {
            this._whenComponentManagerFoundHandlers.forEach(function (me) {
                return function (callback) {
                    callback(me._componentManager);
                }
            }(this));
            // On vide, pour éviter de cabler plusieurs fois les événements du header lorsqu'on appelle la GLOB019 (popins) par exemple
            this._whenComponentManagerFoundHandlers = [];
        }
    }
    /**
     * Méthode surchargeable appelée une fois le IsiComponentManager trouvé
     */
    _componentManagerFoundOverridable(componentManager) {
    }
    /**
     * Permet d'abonner un callback une fois le ISiComponentManager trouvé
     */
    whenComponentManagerFound(callback: (componentManager: IsiComponentManager) => void) {
        if (this._componentManager) {
            callback(this._componentManager);
        } else {
            this._whenComponentManagerFoundHandlers.push(callback);
        }
    }
    isHistoryBack() {
        return this._userJustDoHistoryBack;
    }
    /**
     * Méthode appelée une fois le DOMContentLoaded terminé
     */
    domContentLoadedComplete() {
        this._domContentLoadedCompleteOverridable();
    }
    /**
     * Méthode surchargeable appelée une fois le DOMContentLoaded terminé
     */
    _domContentLoadedCompleteOverridable() {
        //#sonar  : A surcharger pour gérer des chose sur le domcontentloaded.
    }


    _createComponents() {
        for (var i in window.IsiCpFns) {
            let o: any = window.IsiCpFns[i]();
            if (o && typeof o.type !== "undefined") {
                this._componentFactory.createComponent(o.type, o.id, null, o.props, jQuery("#" + o.id));
            }
        }
    }

    createInstanceOfPopInSettings<TOpenArgs, TCallbackArgs>(args: IIsiPopInSettingsConstructorArgs<TOpenArgs, TCallbackArgs>) {
        return this.createInstanceOfPopInSettingsOverridable(args);
    }

    scrollHeightCalculation() {
        /// <summary>
        /// Cette fonction permet de calculer la taille coté client d'une scroll, en fonction du navigateur.
        /// </summary>
        /// <history>
        ///     <entry mat="CLEM" date="06/06/2016" task="122395">Création</entry>
        /// <history>
        let ctrl = document.createElement("DIV");
        let retour;

        ctrl.style.overflow = "scroll";
        ctrl.style.height = "50px";
        document.body.appendChild(ctrl);

        retour = ctrl.offsetHeight - ctrl.scrollHeight;

        document.body.removeChild(ctrl);

        return retour;
    }

    protected createInstanceOfPopInSettingsOverridable<TOpenArgs, TCallbackArgs>(args: IIsiPopInSettingsConstructorArgs<TOpenArgs, TCallbackArgs>) {
        return new IsiPopInSettings<TOpenArgs, TCallbackArgs>(args);
    }

    buildAjaxUrl(url) {
        return this.buildAjaxUrlOverridable(url);
    }

    buildAjaxUrlOverridable(url) {
        return url;
    }
    buildAjaxHandlerUrl(url: string, action: string, accept?, baseUrl?) {
        /// <summary>
        /// Cette fonction construit l'url d'acces a la ressource ASHX du composant, avec l'action précisée
        /// </summary>
        /// <param name="width">La largeur. Si false est passé, la largeur n'est pas modifiée.</param>
        /// <history>
        /// LBRI - 25/03/2014 - DEV84017
        /// <history>

        //GBAU - 24/03/2016 - On autorise de passer false pour indiquer que l'on en veux pas
        //CCAP  - 04/10/2018 - PB0018878 - Correction erreur IE
        if (typeof (accept) == 'undefined') {
            accept = "application/json";
        }

        //GBAU - 19/02/2019 : Ajout de la possibilité de passé le début de l'url (host notemment)
        if (typeof (baseUrl) != 'undefined') {
            url = IsiJsTools.concatUrl(baseUrl, url);
        }

        if (accept !== false) {
            url = addParamToUrl(url, "accept", accept);
        }

        url = addParamToUrl(url, "action", action);

        return this.buildAjaxUrl(url);
    }

    /**
    * Retourne si un string contient du html
    * @param stringToEvaluate
    * @returns
    */
    hasHtml(stringToEvaluate: string) {
        const doc = new DOMParser().parseFromString(stringToEvaluate, "text/html");
        return doc.body.childElementCount !== 0;
    }

    /**
     * renvoie un nombre sous la forme d'un string et il est formaté en fonction de la culture du client
     * Si value n'est pas un nombre, il est renvoyé tel quel
     * @param value
     * @returns
     */
    numberToStringFormatCulture(value: number) {
        if (isNaN(value)) {
            return value;
        }
        else {
            const currentCulture = this.getCurrentCulture();
            return Intl.NumberFormat(currentCulture).format(value);
        }
                
        
    }

    /**
     * Retourne la culture actuelle. Si elle n'est pas définie, la culture du navigateur est renvoyé
     * @returns
     */
    getCurrentCulture() {
        let currentCulture = navigator.language;
        if (this._options.currentCulture) {
            currentCulture = this._options.currentCulture;
        }
        return currentCulture;
    }

    /**
     * retourne le séparateur décimal en fonction de la culture actuel
     * @returns
     */
    getDecimalSeparatorCurrentCulture() {
        const culture = this.getCurrentCulture();
        return new Intl.NumberFormat(culture, {
            minimumFractionDigits: 1
        }).formatToParts(1.1).find(part => part.type === 'decimal').value;
    }

    /**
     * retourne le séparateur des milliers en fonction de la culture actuel
     * @returns
     */
    getThousandsSeparatorCurrentCulture() {
        const culture = this.getCurrentCulture();
        return new Intl.NumberFormat(culture, {
            useGrouping: true
        }).formatToParts(1000).find(part => part.type === 'group').value;
    }
	
    /**
     * retourne la liste des formats des dates
     * @returns
     */
    getListFormatDate() {
        return this._getListFormatDateOverridable();
    }

    /**
     * fonction surchargeable qui retourne la liste des formats de dates
     * @returns
     */
    _getListFormatDateOverridable() {
        return ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY", "HH:mm:ss", "HH:mm"];
    }

}
//---------------------------------------

class IsiInvalidArgumentException {

    arg: any;
    message: string;
    correctTypes: any;
    toString: () => string;

    constructor(arg, correctTypes, message?) {
        this.arg = arg;
        this.message = message;
        this.correctTypes = correctTypes || ["Indéterminé"];
        this.toString = function () {
            var message = "";
            if (this.message) {
                message = "(" + this.message + ")";
            }
            return String.format("L'argument {0} n'est pas du bon type. Le(s) type(s) accepté(s) sont {1}. {2}", this.arg, JSON.stringify(this.correctTypes), message);
        };
    }
}

function IsiInvalidStateException(message) {
    this.message = message;
    this.toString = function () {
        return this.message;
    };
}

function trysetFocusOnPopin() {
    try {
        if (uiCore.getCurrentPopin()) {
            if (typeof uiCore.setFocusOnPopin == 'function') {
                uiCore.setFocusOnPopin();
            }
        }
    } catch (e) {
        uiCore.logError(e.message);
    }
}


//--------------------------------------

/**
 * La configuration
 * @typedef {Object} IsiPopinArgs
 */

/**
 * @class IsiPopInSettings
 * @param {IsiPopinArgs} args Les arguments de construction
 * @property {String} code Code de la popup (code écran)
 * @property {String} id Identifiant de la popup
 * @property {Integer} width Largeur
 * @property {Integer} height Hauteur
 * @returns
 */
export class IsiPopInSettings<TOpenArgs, TCallbackArgs> {

    _code: string;
    _id: string;
    _useTs: boolean;
    _returnValue: TCallbackArgs;
    _callback;
    _width;
    _height;
    _minHeight;
    _openWith: string;
    _type: string;
    _beforeOpen: (args: TOpenArgs, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) => boolean;
    _afterClose: (result: TCallbackArgs) => void;
    _args;
    _options;
    _blockingTreatmentId: string;
    _orientationChangedHandler;
    _sizeChangedHandler;
    // Variable contenant la distance de scroll depuis le haut de l'écran
    _scrollTop;
    _executeModaleChoiceDlg: () => void;

    constructor(args: IIsiPopInSettingsConstructorArgs<TOpenArgs, TCallbackArgs>) {
        this._code = args.code;
        this._id = args.id || "";
        this._useTs = args.useTs || false;
        this._returnValue;
        this._callback;
        this._width = args.width || null;
        this._height = args.height || null;
        this._openWith = args.openWith || "auto";
        this._type = args.type || "iframe";
        this._beforeOpen = args.beforeOpen || function (args, options) { return true; };
        this._afterClose = args.afterClose || function (result) { return true; };
        this._executeModaleChoiceDlg = args.executeModaleChoice || function () { };
        this._args = args.args || false;
        this._options = null;
        this._blockingTreatmentId = null;
        this._orientationChangedHandler;
        this._sizeChangedHandler;
        // Variable contenant la distance de scroll depuis le haut de l'écran
        this._scrollTop = null;
    }

    getCode() {
        return this._code;
    }
    getId() {
        return this._id;
    }
    get useTs() {
        return this._useTs;
    }
    haveReturnValue() {
        return typeof (this._returnValue) !== 'undefined';
    }
    haveCallback() {
        return typeof (this._callback) !== 'undefined';
    }
    getReturnValue() {
        return this._returnValue;
    }
    setReturnValue(value) {
        this._returnValue = value;
    }
    getCallback() {
        return this._callback;
    }
    setCallback(value) {
        this._callback = value;
    }
    getWidth() {
        return this._width;
    }
    getHeight() {
        return this._height;
    }
    getOpenWith() {
        return this._openWith;
    }
    getType() {
        return this._type;
    }
    getArgs() {
        return this._args;
    }
    setArgs(value) {
        this._args = value;
    }
    getBlockingTreatmentId() {
        return this._blockingTreatmentId;
    }
    setBlockingTreatmentId(value) {
        this._blockingTreatmentId = value;
    }
    /**
     * Fonction permettant d'initialiser des choses dans les produits
     * avant l'ouverture de la popin.
     * @param args Les args
     * @param options les options
     */
    protected _beforeOpenOverridable(args?: TOpenArgs, options?: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {

    }
    open(args?: TOpenArgs, options?: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
        uiCore.hideFeedback();
        args = args || <any>{};
        options = options || {};
        options.width = options.width || this.getWidth();
        options.height = options.height || this.getHeight();

        this._beforeOpenOverridable(args, options);
        // On met à jour la largeur et la hauteur pour y avoir accès à l'intérieur des popins
        this._width = options.width;
        this._height = options.height;

        var url = options.url || "";
        var treatmentId = options.treatmentId || "";
        var callback;

        options.args = args;

        this._beforeOpen.apply(this, [options]);

        callback = options.callback || this.getCallbackOverridable();

        options.blocking = options.blocking || typeof (callback) !== 'undefined'; //Une popin est bloquante à partir du moment ou elle à un callback

        uiCore.setCurrentPopin(this);


        switch (this._type) {
            case "iframe":
                var urlArgs = [];
                if (options.args instanceof IsiDataTransferObject) {
                    let cloned = JSON.parse(JSON.stringify(options.args));
                    //On enlève le $type pour limiter la longueur de l'URL
                    delete cloned.$type;
                    urlArgs.push("args=" + encodeURIComponent(JSON.stringify(cloned)));
                } else {
                    for (var d in options.args) {
                        urlArgs.push(encodeURIComponent(d) + "=" + encodeURIComponent(<any>options.args[d]));
                    }
                }

                url = this.buildUrlOverridable(options, urlArgs.join("&"));
                if (!treatmentId) {
                    treatmentId = url;
                }

                break;
        }

        options.url = url;

        this._options = options;
        this.checkWidth()
        // On mode smartphone ou petite tablette, la popin prend tout la place
        if ((options.resizeToFitContent === true) &&
            (uiCore.isRWDPhone())) {
            this._options.width = "calc(100% - 18px)"
        }

        switch (this.getOpenWith()) {

            case "auto":
                uiCore.addUITreatment({
                    func: function (instance: IsiPopInSettings<TOpenArgs, TCallbackArgs>, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
                        return function () {
                            if (options.blocking) {
                                instance.setBlockingTreatmentId(treatmentId);
                            }

                            uiCore.setCurrentPopin(instance);

                            // Cette classe est ajoutée au body de la page appelante à l'ouverture de la popin
                            // Elle sert à spécfier du CSS et/ou Javascript à appliqué à la page appelante PENDANT que la popin est ouverte
                            jQuery("body").addClass("popinOpened");

                            jQuery.fancybox.open({
                                src: options.url,
                                type: instance.getType()
                            }, {
                                spinnerTpl: "",
                                modal: true,
                                iframe: {
                                    preload: false,
                                    css: {
                                        width: options.width,
                                        height: options.height
                                    },
                                    attr: {
                                        scrolling: 'no'
                                    }
                                },
                                beforeLoad: function (me: IsiPopInSettings<TOpenArgs, TCallbackArgs>, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
                                    return function () {
                                        me._beforeLoad(options);
                                    }
                                }(instance, options),
                                afterLoad: function (me: IsiPopInSettings<TOpenArgs, TCallbackArgs>, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
                                    return function () {
                                        me._afterLoad(options);
                                    }
                                }(instance, options),
                                beforeShow: function (me: IsiPopInSettings<TOpenArgs, TCallbackArgs>, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
                                    return function () {
                                        me._beforeShow(options);
                                    }
                                }(instance, options),
                                afterShow: function (me: IsiPopInSettings<TOpenArgs, TCallbackArgs>) {
                                    return function () {
                                        me._afterShow();
                                    }
                                }(instance),
                                afterClose: function (me: IsiPopInSettings<TOpenArgs, TCallbackArgs>, options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
                                    return function (): void {
                                        me._afterClosed(options);
                                    }
                                }(instance, options)
                            });
                        }
                    }(this, options),
                    id: treatmentId,
                    blocking: options.blocking,
                    callback: callback
                });
                break;
        }
    }
    /**
     *  En smartphone si la taille demandée dépasse la taille de l'écran alors on retaille .
     * @param option
     */
    checkWidth() {
       
        if (uiCore.isRWDPhone() && this._options.width && typeof (this._options.width) === 'number' && this._options.width > document.body.clientWidth) {
            this._options.resizeToFitContent = true;
        }
    }
    close(returnValue?) {
        delete popInInstances[this.getId()];
        if (typeof (returnValue) !== 'undefined') {
            this.setReturnValue(returnValue);
        }
        setTimeout(function () {
            jQuery.fancybox.close();
        }, 0);

    }
    /**
     * Traitement lors de lors du retour de la modale.
     * */
    executeModalChoice():void {
        this._executeModaleChoiceDlg();
    }

    _beforeLoad(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {
        this._beforeLoadOverridable(options);
    }
    _beforeLoadOverridable(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {

    }
    _afterLoad(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {
        this._afterLoadOverridable(options);
    }
    _afterLoadOverridable(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {
        // Variables locales
        var iframe;
        var iFrameContent;

        // Récupération de éléments
        iframe = jQuery(fancyboxIframeSelector);
        iFrameContent = jQuery(".fancybox-content");
        iFrameContent.css("visibility", "hidden");
        // Placement de la fonction 'resize' sur l'event onload de l'iframe (i.e. Resize après chargement de l'iframe)
        iframe.on("load", () => {
            jQuery(iframe[0].contentDocument).children("html").addClass("popin")
            // Ajoute la classe 'block' à l'iframe pour la rendre visible uniquement après que son contenu (page aspx) soit complètement chargé
            iFrameContent.addClass("block");
            if (options.resizeToFitContent) {
                // Si demandé l'iframe ajuste sa hauteur par rapport à celle de son contenu
                this._fctResizeToFitContent(iframe, iFrameContent, options.widthToHeightRatio);
            } else {
                this._fctResizeToScreen(iframe, iFrameContent);
            }
            iFrameContent.css("visibility", "visible");
        });

        // Déclaration de la fonction de gestion de changement d'orientation du device
        this._orientationChangedHandler = () => {
            if (options.resizeToFitContent) {
                // Un timeout est nécessaire car Fancybox masque le container lors d'un changement d'orientation 
                // pendant n sec et que ce dernier doit être visible pour calculer des dimensions corrects
                // Pour Trouver le délai utilisé il faut regarder dans jquery.fancybox.js --> orientationchange
                setTimeout(() => {
                    // Si demandé l'iframe ajuste sa hauteur par rapport à celle de son contenu
                    this._fctResizeToFitContent(iframe, iFrameContent, options.widthToHeightRatio);
                }, 251);
            } else {
                this._fctResizeToScreen(iframe, iFrameContent);
            }
        };

        // Déclaration de la fonction de gestion de changement de redimensionnement de la fenêtre
        this._sizeChangedHandler = () => {
            if (options.resizeToFitContent) {
                // Si demandé l'iframe ajuste sa hauteur par rapport à celle de son contenu
                this._fctResizeToFitContent(iframe, iFrameContent, options.widthToHeightRatio);
            } else {
                this._fctResizeToScreen(iframe, iFrameContent);
            }
        };

        // Ajout du handler de changement d'orientation
        uiCore.add_orientationChanged(this._orientationChangedHandler);
        // Ajout du handler de redimensionnement de la fenêtre
        uiCore.add_sizeChanged(this._sizeChangedHandler);
    }

    _beforeShow(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {
        // Verouillage du scroll sur le body de la page appelante (pour éviter des scroll en arrière-plan quand la popin est ouverte)
        this._lockBodyScroll();
        this._beforeShowOverridable(options);
    }
    _beforeShowOverridable(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {

    }
    _afterShow(): void {
        this._afterShowOverridable();
    }
    _afterShowOverridable(): void {

    }
    _afterClosed(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {
        this._afterClosedOverridable(options);

        // Suppression de l'évent sur le changement d'orientation
        uiCore.remove_orientationChanged(this._orientationChangedHandler);
        // Suppression de l'évent sur le redimensionnement de la fenêtre
        uiCore.remove_sizeChanged(this._sizeChangedHandler);

        uiCore.hideFeedback();
        //GBAU RWD
        jQuery("body").removeClass("popinOpened");
        this._options = null;
        if (this.getBlockingTreatmentId()) {
            if (typeof (uiCore) !== 'undefined') {
                //Dans le cas ou la popin bloque un traitement, on doit le débloquer;
                uiCore.unblockTreatment(this.getBlockingTreatmentId(), this.getReturnValue());
            }
        }

        // Déverouillage du scroll sur le body de la page appelante
        this._unlockBodyScroll();

        uiCore._afterClosePopin(this);

        //GBAU - 30/03/2016 - Déplacement de l'appel à la méthode _afterClose avant l'appel au callback
        if (this._afterClose) {
            //Un délégué à été fourni, on l'appelle
            this._afterClose.apply(this, [this.getReturnValue()]);
        }

        if (this.haveReturnValue()) {
            if (this.haveCallback()) {
                this.getCallback()(this.getReturnValue());
            }/* else {
                execUserModalChoice(this.getId(), this.getReturnValue());
            }*/
        }
    }
    _afterClosedOverridable(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>): void {

    }
    buildUrlOverridable(options: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>, urlArgs: string): string {
        return options.url;
    }
    getCallbackOverridable() {
        return function (result) {
            return result;
        }
    }
    getOptions() {
        return this._options;
    }

    /**
    * Force le recalcul de la taille de la popin courante.
    * Utilisé lorsque le contenu de la popin évolue dynamiquement.
    */
    public resizePopin(): void {
        if (!this._options) { return };

        const iframe: JQuery = jQuery(fancyboxIframeSelector);
        const iFrameContent: JQuery = jQuery(".fancybox-content");

        if (this._options.resizeToFitContent) {
            this._fctResizeToFitContent(iframe, iFrameContent, this._options.widthToHeightRatio);
        } else {
            this._fctResizeToScreen(iframe, iFrameContent);
        }
    }

    /**
     * Calcule la hauteur de la popin (titre + contenu + boutons)
     * à partir des tailles réellement affichées à l’écran.
     *
     * Chaque bloc est optionnel : s’il n’existe pas, sa hauteur vaut 0.
     * La valeur finale est arrondie vers le haut pour éviter les coupes d’1px.
     *
     * @param iframe Iframe Fancybox (wrapper jQuery).
     * @returns Hauteur totale de la popin (en pixels).
     */
    private _calculatePopinHeight(iframe: JQuery): number {

        const ifr: HTMLIFrameElement = iframe[0] as HTMLIFrameElement;
        const doc:Document = ifr.contentWindow.document;

        const h1:number = doc.querySelector(".popInTittleContainer")?.clientHeight ?? 0;
        const h2:number = doc.querySelector("#designContainer")?.clientHeight ?? 0;
        const h3:number = doc.querySelector(".rowBtnPopin")?.clientHeight ?? 0;

        return Math.ceil(h1 + h2 + h3);
    }

    _fctResizeToFitContent(iframe, iFrameContent, desiredWidthToHeightRatio) {
        // Hauteur du body à l'intérieure de l'iframe
        let currentBodyHeight;
        // Largeur du body à l'intérieure de l'iframe
        let currentBodyWidth;

        let JQDocument = jQuery(iframe[0].contentWindow.document);
        let frameBody = iframe[0].contentWindow.document.body;

        if (frameBody.clientWidth === 0) {
            currentBodyWidth = JQDocument.width();
        } else {
            currentBodyWidth = frameBody.clientWidth;
        }

        //on calcule la taille du contenu de la popin
        let jPopinBody = jQuery(frameBody);
        let jrowButton = jPopinBody.find(".rowBtnPopin");
        jrowButton.css("position", "relative");
        jPopinBody.css("height", "auto");

        const calculatedHeight = this._calculatePopinHeight(iframe);
        const realBodyHeight = calculatedHeight > 0 ? calculatedHeight : jPopinBody.height();

        jrowButton.css("position", "");
        jPopinBody.css("height", "");

        if (desiredWidthToHeightRatio === undefined) {
            // On reprend la taille réelle du contenu de la popin
            currentBodyHeight = Math.floor(realBodyHeight) + 1;
        }
        else {
            // Récupère la hauteur actuelle du body à l'intérieure de l'iframe
            if (frameBody.clientHeight === 0) {
                currentBodyHeight = JQDocument.height();
            } else {
                currentBodyHeight = frameBody.clientHeight;
            }

            // On applique le ratio sur la hauteur pour calculé la largeur
            currentBodyWidth = Math.floor(currentBodyHeight / desiredWidthToHeightRatio) + 1;
        }
        // On appel la fonction qui redimentionne la popin si elle dépasse de l'écrant 
        this._fctResizeToScreen(iframe, iFrameContent, currentBodyWidth, currentBodyHeight);
    }
    _fctResizeToScreen(iframe, iFrameContent, currentBodyWidth?, currentBodyHeight?) {
        // Hauteur de la fenêtre du navigateur
        let windowHeight;
        // Largeur de la fenêtre du navigateur
        let windowWidth;
        // Hauteur maximale que peux prendre l'iframe avant que la marge superieure ne soit appliquée
        let iFrameMaxHeight;
        // Largeur maximale que peux prendre l'iframe avant que les marges latérales ne soient appliquées
        let iFrameMaxWidth;

        // Récupère les dimensions de la fenêtre du navigateur
        windowWidth = jQuery(window).width();
        windowHeight = jQuery(window).height();

        // Calcul des largeur/hauteur maximales de l'iframe ET les marges entre le conteneur de l'iframe et le device (varie selon le type de device)
        switch (uiCore.getClient().RWDMode) {
            case IsiRWDMode.Phone:
                iFrameMaxWidth = windowWidth - 18; // Marges de 9px
                iFrameMaxHeight = windowHeight - 18;
                break;
            case IsiRWDMode.Tablet:
            case IsiRWDMode.Desktop:
                switch (uiCore.getClient().RWDLength) {
                    case IsiRWDLength.Small:
                        iFrameMaxWidth = windowWidth - 34; // Marges de 17px
                        iFrameMaxHeight = windowHeight - 34;
                        break;
                    case IsiRWDLength.Medium:
                        iFrameMaxWidth = windowWidth - 50; // Marges de 25px
                        iFrameMaxHeight = windowHeight - 50;
                        break;
                    case IsiRWDLength.Large:
                        iFrameMaxWidth = windowWidth - 120; // Marges de 60px
                        iFrameMaxHeight = windowHeight - 120;
                        break;
                }
                break;
        }

        let JQDocument = jQuery(iframe[0].contentWindow.document);
        let frameBody = iframe[0].contentWindow.document.body;
        // On vérifie si le currentBodyHeight n'a pas été passé en paramètre, auquel cas on lui affecte une valeur
        if (currentBodyHeight === undefined) {
            // On récupère les dimensions actuelles du body à l'intérieur de l'iframe
            if (frameBody.clientHeight === 0) {
                currentBodyHeight = JQDocument.height();
            } else {
                currentBodyHeight = frameBody.clientHeight + 1; // ajout de 1 pour contrecarrer la perte de 1px en hauteur à chaque rafraichissement de la popin (due à un arrondi ?)
            }
        }
        // On verifie si le currentBodyWidth n'a pas été passé en paramètre auquel cas on lui en affecte
        if (currentBodyWidth !== undefined) {
            // On écupère les dimensions actuelles du body à l'intérieure de l'iframe
            if (frameBody.clientWidth === 0) {
                currentBodyWidth = JQDocument.width();
            } else {
                currentBodyWidth = frameBody.clientWidth;
            }
        }

        // On vérifie si on a atteint la largeur max
        currentBodyWidth = Math.min(currentBodyWidth, iFrameMaxWidth);

        // On vérifie si on a atteint la largeur max
        currentBodyHeight = Math.min(currentBodyHeight, iFrameMaxHeight);

        // Mise en place de la nouvelle largeur du body dans l'iframe
        frameBody.style.width = currentBodyWidth + 'px';

        //RADE 11/04/24 BUG 77069 Mise en place d'une taille minimum de popin pour que ses éléments restent en place lors du zoom/dezoom
        if (this._minHeight === undefined) {
            this._minHeight = currentBodyHeight;
            // Initialisation de la hauteur minimum de la popin si on fait un resize 
        } else if (currentBodyHeight !== undefined && this._minHeight !== currentBodyHeight) {
            this._minHeight = currentBodyHeight;
        }
        frameBody.style.minHeight = this._minHeight + 'px';

        // Mise en place de la nouvelle largeur de l'iframe
        iFrameContent.width(currentBodyWidth);

        // Mise en place de la hauteur de l'iframe pour qu'elle corresponde à la hauteur du body dans l'iframe
        iFrameContent.height(currentBodyHeight);
    }
    /**
     * Vérouille le scroll sur le body (utiliser quand la IsiPopin est affichée)
     * @author MBRO
     * @date 25/09/2018 10:47:21
     * @dysf 84180
     */
    _lockBodyScroll() {
        if (window.pageYOffset) {
            // Si un scroll est actuellement présent on le sauvegarde
            this._scrollTop = window.pageYOffset;
        } else {
            this._scrollTop = 0;
        }

        if (uiCore.browser.isSafari()) {
            // Sous Safari l'ouverture du clavier virtuel provoque un déplacement du contenu de la page vers le haut.
            // Pour compenser il faut 'scroller' tout en haut de la page
            // MAIS il faut attendre 300ms pour que la barre de navigation passe de sa hauteur réduite à sa hauteur standard
            // (fonctionnalité iOS pour que la barre de navigation prenne mois de place pendant un scroll sur une page).
            window.setTimeout(function () {
                window.scrollTo(0, 0);
            }, 300);
        }

        // On empêche le scroll sur le document via css
        jQuery("body").css({
            position: "fixed",
            overflow: "hidden",
            top: -this._scrollTop
        });
    }
    /**
     * Dévérouille le scroll sur le body (utiliser quand la IsiPopin est masquée)
     * @author MBRO
     * @date 25/09/2018 10:47:21
     * @dysf 84180
     */
    _unlockBodyScroll() {
        // On retire le css empêchant le scroll du body
        jQuery("body").css({
            position: "",
            overflow: "",
            top: ""
        });

        // On se repositionnement sur la fenêtre au niveau de scroll avant l'affichage de la popin
        window.scrollTo(0, this._scrollTop);
        window.setTimeout(function () {
            this._scrollTop = null;
        }, 0);
    }
}

// Récupère l'instance de la popin entre la iframe et le conteneur la iframe.
export function getPopInInstance<TOpenArgs, TCallbackArgs>(id, args: IIsiPopInSettingsConstructorArgs<TOpenArgs, TCallbackArgs>) {
    let instance: IsiPopInSettings<TOpenArgs, TCallbackArgs>;

    //GBAU : Dans le cas ou la fenêtre n'est pas dans un cadre parent (frameset), le window.top est identique au window.parent,
    // le test entre window et window.parent est quand a lui OK
    //https://developer.mozilla.org/fr/docs/Web/API/Window/parent
    if (window !== window.parent && typeof (window.parent.getPopInInstance) !== 'undefined') {
        instance = <IsiPopInSettings<TOpenArgs, TCallbackArgs>>window.parent.getPopInInstance(id, args);
    } else {
        instance = popInInstances[id];
        if (typeof (instance) === 'undefined') {
            args = args || { code: "", id: id, beforeOpen: null, afterClose: null };
            args.id = id;
            instance = uiCore.createInstanceOfPopInSettings(args)//new IsiPopInSettings(args);
            popInInstances[instance.getId()] = instance;
        }
    }

    return instance;
}
window.getPopInInstance = getPopInInstance;

//----------------

function IsiScreen(args) {
    this._beforeFormAction = args.beforeFormAction || false;
    this._afterBusinessCheck = args.afterBusinessCheck || false;
}

IsiScreen.prototype = {
    showConfirm: function (msg, confirmMode, callback) {
        window.screenCore.showConfirm(msg, confirmMode, callback)
    },
    beforeFormAction: function () {
        if (this._beforeFormAction) {
            this._beforeFormAction.call(this);
        }
    },
    afterBusinessCheck: function () {
        if (this._afterBusinessCheck) {
            this._afterBusinessCheck.call(this);
        }
    }

}

class IsiGraphViz {
    _treatments = {};
    _treatmentId: number;
    _report: string;
    _nextExecuteOrderCounter: number;

    constructor() {
        this._treatments = {};
        this._treatmentId = 0;
        this._report = "";
        this._nextExecuteOrderCounter = 0;
        //jQuery(document).ready(function (me) {
        //    return function () {
        //        me._initialize();
        //    }
        //}(this));
    }

    initialize() {

        // CLEM - Dysf74129 - Pas de bouton si pas de trace active
        if (uiCore.getIsModeDiag()) {
            var jElement;
            jElement = jQuery('<div></div>');
            jElement.addClass("treatmentLogger");
            jQuery(document.body).prepend(jElement);

            var jPrevious;
            jPrevious = jQuery('<div class="prev"></div>');
            jElement.append(jPrevious);

            var jCurrent;
            jCurrent = jQuery('<div class="current"></div>');
            jElement.append(jCurrent);

            jPrevious.on("click", function (me) {
                return function () {
                    var previousReport = window.isiLocalStorage.getItem("IsiPreviousGvReport");
                    if (previousReport) {
                        me.launchDownload(previousReport, this);
                    }
                }
            }(this));

            jCurrent.on("click", function (me) {
                return function () {
                    me.launchDownload(me.writeReport(), this);
                }
            }(this));

            jQuery(window).on("beforeunload", function (me) {
                return function (e) {
                    var fileContent = me.writeReport();
                    //var url = "data:text/plain;charset=utf-8," + encodeURIComponent(fileContent);
                    window.isiLocalStorage.setItem("IsiPreviousGvReport", fileContent)
                }
            }(this));
        }
    }
    launchDownload(reportContent, parent) {
        var jElementLink;
        jElementLink = jQuery("a", jQuery(parent).parent());
        if (jElementLink.length == 0) {
            jElementLink = jQuery("<a></a>");
            jQuery(parent).parent().append(jElementLink);
        }

        var fileContent = reportContent;
        var fileName = "report.gv";

        if (window.navigator.msSaveOrOpenBlob) {
            var fileData = [fileContent];
            let blobObject = new Blob(fileData);
            jElementLink.on("click", function () {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
        } else {
            var url = "data:text/plain;charset=utf-8," + encodeURIComponent(fileContent);
            jElementLink.attr("download", fileName);
            jElementLink.attr("href", url);
        }

        //jElementLink.on("click", function (e) {
        //    e.stopPropagation();
        //    e.preventDefault();
        //});

        jElementLink.trigger("click");

        var date = new Date();
        var title = String.IsiFormat('Graph ({0} - {1}:{2}:{3})', jQuery(parent).attr('class'), date.getHours(), date.getMinutes(), date.getSeconds());
        jElementLink.attr('title', title).addClass('dlLink');


    }
    writeReport() {
        this._report = "digraph G {";
        this._report += "node [shape=box, color=blue, style=bold, margin=0, penwidth=1];";
        this._report += "start -> 0;";

        for (var i in this._treatments) {
            var treatment = this._treatments[i];
            this._report += String.IsiFormat('{0} -> {1} [color="#000000", label="{2}", penwidth=1];', treatment.parentTreatmentId, treatment.treatmentId, treatment.executeOrder.join());
            this._report += String.IsiFormat('{0} [label=<{1}>,labelloc=b];', treatment.treatmentId, this._buildTreatmentLabel(treatment));
        }

        this._report += "0 -> end;";
        this._report += "start [shape=Mdiamond];";
        this._report += "end [shape=Msquare];";
        this._report += "}";

        return this._report;
    }
    _buildTreatmentLabel(treatmentInfos) {
        var formattedLabel = "";
        var datas = new Array();

        if (typeof (treatmentInfos.result) === 'undefined') {
            treatmentInfos.result = "Pas de valeur";
        }

        datas.push({ label: "Retour", value: treatmentInfos.result });

        treatmentInfos.logs.push({ label: "Blocking", value: treatmentInfos.treatment.getBlocking() });
        treatmentInfos.logs.push({ label: "IsSubmit", value: treatmentInfos.treatment.getIsSubmit() });
        treatmentInfos.logs.push({ label: "IsAlert", value: treatmentInfos.treatment.getIsAlert() });
        treatmentInfos.logs.push({ label: "Executed", value: treatmentInfos.treatment.wasExecuted() });

        if (treatmentInfos.treatment.getCallbackOf()) {
            treatmentInfos.logs.push({ label: "CallBackOf", value: treatmentInfos.treatment.getCallbackOf().getId() });
        }

        if (treatmentInfos.treatment.getParentTreatment()) {
            treatmentInfos.logs.push({ label: "Parent", value: treatmentInfos.treatment.getParentTreatment().getId() });
        }

        for (var i in treatmentInfos.logs) {
            var logData = treatmentInfos.logs[i];
            var log;
            if ((logData !== null) && (typeof logData === "object")) {
                log = logData;
            } else {
                log = { label: "Log", value: logData };
            }
            datas.push(log);
        }

        formattedLabel += '<table cellspacing="0" cellpadding="0">';
        formattedLabel += String.IsiFormat('<tr><td colspan="2">{0}</td></tr>', this._formatLabel(treatmentInfos.label));

        for (var i in datas) {
            var data = datas[i];
            formattedLabel += String.IsiFormat('<tr><td>{0}</td><td>{1}</td></tr>', this._formatLabel(data.label), this._formatLabel(data.value));
        }

        formattedLabel += "</table>";
        return formattedLabel;
    }
    _formatLabel(label) {
        if (typeof (label) !== "undefined" && label !== null) {
            label = label.toString();

            label = label.IsiReplaceAll("&", "&amp;");
        } else {
            label = "";
        }

        return label;
    }
    getNewTreatmentId() {
        this._treatmentId++;
        return this._treatmentId;
    }
    addNewTreatment(treatment) {
        var treatmentInfos = {
            treatmentId: treatment.getLogReportId(),
            parentTreatmentId: treatment.getParentLogReportId() || 0,
            label: treatment.getId(),
            logs: new Array(),
            executeOrder: new Array(),
            treatment: treatment
        }



        this._treatments[treatment.getId()] = treatmentInfos;
        return treatmentInfos;
    }
    getTreatment(id) {
        return this._treatments[id];
    }
    _replaceAll(string, value, replacement) {
        var index = 0;
        do {
            string = string.replace(value, replacement);
        } while ((index = string.indexOf(value, index + 1)) > -1);
        return string;
    }
    getNextExecuteOrderCounter() {
        return this._nextExecuteOrderCounter++;
    }
}

class IsiTranslationMessage {

    _familyCode: string;
    _messageCode: string;
    _message: string;
    IsiLabel: string;

    constructor(settings) {
        this._familyCode = settings.familyCode || settings.IsiFamilyCode;
        this._messageCode = settings.messageCode || settings.IsiMessageCode;
        this._message = settings.message || settings.IsiLabel;
        this.IsiLabel = this._message;
    }

    toString() {
        return this._message;
    }
    //methodes
    // equivalent du buildsql pour les chaine $s
    BuildSQL(aParam) {
        var indice = 0;
        var iNext = 0;
        var sRes = this._message;
        //FSARVIO
        while (sRes.indexOf("$q", iNext) != -1) {
            //On reprend la position du caractere trouve
            var iFind = sRes.indexOf("$q", iNext);
            //chaine avant le caractere
            var sBefore = sRes.substring(0, iFind);
            //chaine apres le caractere
            var sAfter = sRes.substring(iFind + 2, sRes.length);
            sRes = sBefore + aParam[indice] + sAfter;
            //on reprend le test du caractere dans la chaine apres la concatenation
            iNext = sBefore.length + aParam[indice].length + 1;
            indice++;
        }
        return sRes;
    }
}

export class HtmlUtilities {

    private constructor() { }

    /**
     * Retourne la chaine de caractère en remplaçant tous les caractères spéciaux par leurs entités HTML
     * @param str Chaîne de caractères à traiter
     */    
    public static encode(str: string): string {
        const div = document.createElement('div');
        const text = document.createTextNode(str);
        div.appendChild(text);
        return div.innerHTML;
    }

    /**
     * Retourne la chaine de caractère en remplaçant toutes les entités HTML par leurs caractères correspondant
     * @param str Chaîne de caractères à traiter
     */
    public static decode(str: string): string {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = str;
        return textarea.value;
    }

    /**
     * Nettoie un contenu HTML en supprimant ou neutralisant les éléments pouvant conduire 
     * à une exécution de code côté client (XSS).
     * Utilise la librairie HtmlSanitizer (DOMPurify).
     * @param content Contenu HTML potentiellement dangereux fourni par un utilisateur ou une source externe.
     */
    public static sanitizeHtmlContentForXss(content: string): string {
        if (!content) return content;

        const purifiedContent: string = window.DOMPurify.sanitize(content);
        return purifiedContent;
    }
}

window.htmlUtilities = HtmlUtilities
